(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["quick-view"]) return;
  try {
    
  function updateAddToCartButtonQuickview() {
    let modal = $('#other-product-modal');
    if (modal.find("#band-size-other option:selected").attr('data-available') === 'true') {
      modal.find('.add-item-other').removeClass('d-none');
      modal.find('.notify-me-other').addClass('d-none');
      modal.find('.out-of-stock-other').addClass('d-none');
    } else {
      modal.find('.add-item-other').addClass('d-none');
      modal.find('.notify-me-other').removeClass('d-none');
      modal.find('.out-of-stock-other').removeClass('d-none');
    }
  }

  function updateAddToCartButtonQuickviewMob() {
    let modal = $('#other-product-modal');
    if (modal.find(".mobile-add-to-cart option:selected").attr('data-available') === 'true' || modal.find(".mobile-add-to-cart option:selected").val() === 'add') {
      modal.find('.add-item-other').removeClass('d-none');
      modal.find('.notify-me-other').addClass('d-none');
      modal.find('.out-of-stock-other').addClass('d-none');
    } else {
      modal.find('.add-item-other').addClass('d-none');
      modal.find('.notify-me-other').removeClass('d-none');
      modal.find('.out-of-stock-other').removeClass('d-none');
    }
  }

  function addThumbnailEventsQuickview(parent) {
    parent.find('.picker-thumbnails,.play-overlay').click(function(){
  	if ($(this).attr('data-is-video')) {
  	  parent.find('.main-image').addClass('d-none');
        $('#quickview-prod-vid').removeClass('d-none');
        $('#quickview-prod-vid video').trigger('play');
      } else {
  	  $('#quickview-prod-vid video').trigger('pause');
  	  $('#quickview-prod-vid').addClass('d-none');
  	  parent.find('.main-image').removeClass('d-none');
        parent.find('.main-image').html($(this).html());
        parent.find('.main-image').find('img').removeClass('p-1');
        parent.find('.main-image').find('img').removeClass('border');
        parent.find('.main-image').find('img').addClass('img-fluid');
      }
      parent.find('.picker-thumbnails').find('img').removeClass('border');
      $(this).parent().find('.thumb-image').addClass('border');
    });
  }

  function replaceProductQuickview(parent, product, variantId) {

    let carosel = parent.find('.carousel').find('.carousel-inner');
    $('#quickview-prod-vid').addClass('d-none');
    parent.find('.main-image').removeClass('d-none');

    carosel.empty();
    let caroselIndicators = parent.find('.carousel-indicators');
    caroselIndicators.empty();
    parent.find('.thumbnails').empty();
    let carouselIndicatorsHtml = '';
    let carouselCount = 0;
    $.each(product.images,function(key,image) {
      let thumbnailHtml = '<div class="pb-2 pr-2"><picture class="picker-thumbnails">';

      let sizeWidths = Object.keys(image.sizes).reverse();
      let sizes = Object.values(image.sizes).reverse();
      $.each(sizes,function(key,size) {
        if (key >= sizes.length-2) {
          return;
        }
        thumbnailHtml += '<source media="(min-width: '+sizeWidths[key+1]+'px)" srcset="'+size+'">';
      });
      thumbnailHtml += '<img class="img-fluid p-1 thumb-image '+(key == 0 ? 'border' : '')+'" src="'+image.sizes['105']+'" alt="'+image.alt+'">'+
        '</picture></div>';

      parent.find('.thumbnails').append(thumbnailHtml);

      let caroselHtml = '<div class="text-center carousel-item '+(key == 0 ? 'active' : '')+'">'+
                            '<picture>';
      $.each(sizes,function(key,size) {
        if (key >= sizes.length-2) {
          return;
        }
        caroselHtml += '<source media="(min-width: '+sizeWidths[key+1]+'px)" srcset="'+size+'">';
      });
      caroselHtml += '<img class="" src="'+image.sizes['105']+'" alt="'+image.alt+'">';
      caroselHtml += '</picture></div>';
      carosel.append(caroselHtml);

      carouselIndicatorsHtml += '<li data-target="#carouselQuickView" data-slide-to="'+carouselCount+'" '+(carouselCount == 0 ? 'class="active"' : '')+'></li>';
      carouselCount++;
    });


        if (product.video) {
    		carouselIndicatorsHtml += '<li data-target="#carouselQuickView" data-slide-to="'+carouselCount+'" '+((carouselCount == 0) ? 'class="active"' : '')+'></li>';

  		let thumbnailHtml = '<div class="pb-2 pr-2 position-relative"><picture class="picker-thumbnails" data-is-video="true">';
  		let image = product.images[0];
  		let sizeWidths = Object.keys(image.sizes).reverse();
          let sizes = Object.values(image.sizes).reverse();
          $.each(sizes,function(key,size) {
            if (key >= sizes.length-2) {
              return;
            }
            thumbnailHtml += '<source media="(min-width: '+sizeWidths[key+1]+'px)" srcset="'+size+'">';
          });
          thumbnailHtml += '<img class="img-fluid p-1 thumb-image" data-is-video="true" src="'+image.sizes['105']+'" alt="'+image.alt+'">'+
            '</picture><img class="play-overlay" data-is-video="true" src="https://cdn.shopify.com/s/files/1/0052/4848/3421/t/14/assets/play_button.png"></div>';

          parent.find('.thumbnails').append(thumbnailHtml);

  		$('#quickview-prod-vid').empty();
          let vidHtml = '<video playsinline="playsinline" loop="loop" class="img-fluid" preload="metadata" aria-label="'+product.video.alt+'" poster="">';
          $.each(product.video.formats, function(key,val){
            vidHtml += '<source src="'+val+'" type="'+key+'">';
          });
          vidHtml += '</video>';
          $('#quickview-prod-vid').html(vidHtml);


          let vidHtmlMob = '<video playsinline="playsinline" loop="loop" class="video-mob" preload="metadata" aria-label="'+product.video.alt+'" poster="">';
          $.each(product.video.formats, function(key,val){
            vidHtmlMob += '<source src="'+val+'" type="'+key+'">';
          });
          vidHtmlMob += '</video>';
          let caroselHtml = '<div class="text-center carousel-item">'+vidHtmlMob+'</div>';

          carosel.append(caroselHtml);
        }
        caroselIndicators.append(carouselIndicatorsHtml);




    parent.find('.main-image').empty();
    let mainImage = product.images[0];
    let mainImageHtml = '';
    let sizeWidths = Object.keys(mainImage.sizes).reverse();
    let sizes = Object.values(mainImage.sizes).reverse();
    $.each(sizes,function(key,size) {
      if (key >= sizes.length-2) {
        return;
      }
      mainImageHtml += '<source media="(min-width: '+sizeWidths[key+1]+'px)" srcset="'+size+'">';
    });
    mainImageHtml += '<img class="img-fluid" src="'+mainImage.sizes['105']+'" alt="'+mainImage.alt+'">';
    parent.find('.main-image').html(mainImageHtml);

    let colorNameText = parent.find('.colour-name').find('b');
    colorNameText.text(product.colour);

    parent.find('.colour-picker').removeClass('border');

    parent.find('.description').html('<hr>'+product.description);

    let priceElement = parent.find('.price');
    let priceContainer = parent.find('.price-stars');
    let currency = priceContainer.attr('data-currency');
    priceContainer.find('.discount').remove();
    $.each(product.tags,function(key,tag){
      if (tag.substring(0,12) == 'discount_'+currency) {
  	  let message = tag.replace('discount_'+currency,'');
  	  priceContainer.append('<span class="discount">'+message+'</span>');
  	}
    });

    priceElement.text(priceElement.attr('data-format').replace('0.00', (product.price/100).toFixed(2)));

    let bandSize = parent.find('.band-size');
    let selectedIndex = bandSize.prop('selectedIndex');

    bandSize.attr('data-image-url', mainImage.sizes['360']);
    bandSize.attr('data-price', product.price);
    bandSize.attr('data-product-title', product.title);
    bandSize.attr('data-handle', product.handle);
    bandSize.attr('data-product-id', product.id);
    bandSize.empty();

    let mobileAddCart = parent.find('.mobile-add-to-cart');
    mobileAddCart.attr('data-image-url', mainImage.sizes['360']);
    mobileAddCart.attr('data-price', product.price);
    mobileAddCart.attr('data-product-title', product.title);
    mobileAddCart.attr('data-handle', product.handle);
    mobileAddCart.attr('data-product-id', product.id);
    mobileAddCart.empty();
    mobileAddCart.append('<option value="add">Add to cart</option>');

    $.each(product.variants,function(key,variant) {
      let mobOptionHtml = '<option value="'+variant.id+'" data-available="'+(variant.available ? 'true' : 'false')+'">'+
                      variant.title + (variant.available ? '' : ' - Sold Out')+
                    '</option>';
      mobileAddCart.append(mobOptionHtml);

  	let optionHtml = '';
      if (!variantId) {
        optionHtml = '<option '+(key == selectedIndex ? 'selected="selected"' : '')+' value="'+variant.id+'" data-available="'+(variant.available ? 'true' : 'false')+'">'+
                          variant.title + (variant.available ? '' : ' - Sold Out')+
                        '</option>';
  	} else {
  	  optionHtml = '<option '+(variantId == variant.id ? 'selected="selected"' : '')+' value="'+variant.id+'" data-available="'+(variant.available ? 'true' : 'false')+'">'+
                          variant.title + (variant.available ? '' : ' - Sold Out')+
                        '</option>';
  	}
      bandSize.append(optionHtml);

    });

    addThumbnailEventsQuickview(parent);
  }


  $(document).ready(function() {
    let quickViewModal = $('#other-product-modal');

    quickViewModal.find("#band-size-other").change(function(){
      updateAddToCartButtonQuickview();
    });
    quickViewModal.find(".mobile-add-to-cart").change(function(){
      updateAddToCartButtonQuickviewMob();
    });

    quickViewModal.on('show.bs.modal', function (event) {
      let button = $(event.relatedTarget); // Button that triggered the modal
      let handle = button.data('handle');
      let variantId = button.data('varaint-id');

      if (handle === undefined) {
        handle = $(this).attr('data-handle');
      }
      let modal = $(this);

      allProductsLoader(function(allProducts) {

        if (!allProducts[handle]) {
          window.location = '/products/'+handle;
          return;
        }

        let product = allProducts[handle];


        replaceProductQuickview(modal, product, variantId);
        updateAddToCartButtonQuickview();

        modal.find('#main-title-other').text(product.title.replace(product.colour,''));
        modal.find('.view-details').attr('href','/products/'+product.handle);

        let circleContainer = $('#other-product-modal').find('.alternate-colours').find('.colour-circles');
        circleContainer.empty();
        $.each(product.colour_group,function(key,handle) {
          if (allProducts[handle] && allProducts[handle].online) {
            let colourCircleHtml = '<a href="/products/'+handle+'" data-handle="'+handle+'" class="colour-picker colour-picker-modal rounded-circle mr-2 '+(handle == product.handle ? 'border' : '' )+'">';
            colourCircleHtml += '<img class="rounded-circle" src="'+allProducts[handle].swatch+'" alt="Alternate colour">';
            colourCircleHtml += '</a>';
            circleContainer.append(colourCircleHtml);
          }
        });
        $('.colour-picker-modal').click(function(e) {
          e.preventDefault();
          changeColourQuickview(modal, $(this).attr('data-handle'));
          $(this).addClass('border');

        });

      });

    });

  });

  function changeColourQuickview(modal, handle) {
    modal.find('.modal-body').height($('#other-product-modal').find('.modal-body').height());
    allProductsLoader(function(allProducts) {
      let product = allProducts[handle];

      replaceProductQuickview(modal, product);
      updateAddToCartButtonQuickview();
    });
    modal.find('.view-details').attr('href','/products/'+handle);
    setTimeout(function() {
      modal.find('.modal-body').height('');
    },2000);
  }



  $(function () {

    let modal = $('#other-product-modal');

    modal.find('.add-item-other').click(function(e){
      let dropdown = $('#other-product-modal').find("#band-size-other");
      let selectedOption = $('#other-product-modal').find("#band-size-other option:selected");
      if (selectedOption.attr('data-available') === 'true') {
        addToSideCart(selectedOption.val(),dropdown.attr('data-price'),dropdown.attr('data-image-url'),dropdown.attr('data-product-title'),selectedOption.html(),dropdown.attr('data-handle'));
        modal.modal('hide');
        showSideCart();
      }
    });

    modal.find('.mobile-add-to-cart').on('change', function() {
      if (this.value !== 'add') {
        let dropdown = $(this);
        let selectedOption = dropdown.find('option:selected');
        if (selectedOption.attr('data-available') === 'true') {
          addToSideCart(selectedOption.val(),dropdown.attr('data-price'),dropdown.attr('data-image-url'),dropdown.attr('data-product-title'),selectedOption.html(),dropdown.attr('data-handle'));
          modal.modal('hide');
          showSideCart();
        }
      }
    });

    modal.find(".current-colour").click(function(e) {
      e.preventDefault();
      modal.find(".alternate-colours").toggleClass('no-show');
    });

    modal.find('.notify-me-other').click(function() {

      modal.find('.success-other').removeClass('d-none');

      setTimeout(function(){
        modal.find('.success-other').addClass('d-none');
      },5000);
      let klavyoKey = $('#other-product-modal').attr('data-klaviyo-key');
      let variant_id = ($('.mobile-add-to-cart').val() === 'add' ? $("#band-size-other option:selected").val() : $('.mobile-add-to-cart').val());
      let product_id = ($('.mobile-add-to-cart').val() === 'add' ? $("#band-size-other").attr('data-product-id') : $('.mobile-add-to-cart').attr('data-product-id'));
      let formData = {'a': klavyoKey,'email': $('#modal-notify-email').val(),
        'variant': variant_id, 'g': '',
        'product': product_id,'platform': 'shopify',
        'subscribe_for_newsletter' : false};
      $.post('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',$.param(formData));

      //let formData = {'variant_id': $("#band-size-other option:selected").val(), 'destination': $('#modal-notify-email').val(),'alertType': 'email', 'domain': $('#size-modal').attr('data-store-url')};
      //$.post('https://outofstock.eastsideco.io/api/create-alert',$.param(formData));
    });

  });

  $('#carouselQuickView').on('slide.bs.carousel', function (event) {
    let vid = $(event.relatedTarget).find('video');
    if (vid.hasClass('video-mob')) {
      vid.trigger('play');
    } else {
      $('.video-mob').trigger('pause');
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-quiz-bottoms"]) return;
  try {
    
  $('.bottom-clickable').click(function(){
    let selectedVal = $('input[name="bottom_size"]:checked').val();
    $('[name="band_size"]').removeAttr('checked');
    $("input[name=band_size][value=" + selectedVal + "]").prop('checked', true);
  });

  $('.band-clickable').click(function(){
    let selectedVal = $('input[name="band_size"]:checked').val();
    $('[name="bottom_size"]').removeAttr('checked');
    $("input[name=bottom_size][value=" + selectedVal + "]").prop('checked', true);
  });


      $('.size-quiz-bottoms .start-btn').on('click', function () {
          setTimeout(function () {
              $('.mobile-scroll').scrollLeft(60);
          }, 10);
      });


      $('.size-quiz-bottoms #slide3-btn-2').on('click', function () {
          if (!$('input[name=stage]:checked').val()) {
              $('input[name=stage]').eq(1).prop("checked", true);
          }
      });


      let stages = ['1st Trimester', '1st Trimester', '2nd Trimester', '3rd Trimester', 'Postpartum', 'Neither, just love Cadenshae!', 'Neither, just love Cadenshae!'];
      addMobileSlider("jssor_bt_1", stages, '.pregnancy-stage', 550, 'stage');



      function addMobileSlider(elementId, selectionTexts, parentSelector, slideWidth, radioName) {
          window.jssor_1_slider_init = function () {

              var slider_options = {
                  $AutoPlay: 0,
                  $SlideWidth: slideWidth,
                  $Loop: 0,
                  $StartIndex: 2
              };

              var slider = new $JssorSlider$(elementId, slider_options);

              slider.$On($JssorSlider$.$EVT_PARK, function (slideIndex, fromIndex) {
                  var slideIndex2 = Math.round(slider.$CurrentPosition());
                  $(parentSelector).find('.slider-text').text(selectionTexts[slideIndex2]);

                  if (slideIndex2 == 0) {
                      slider.$PlayTo(1);
                  }
                  if (slideIndex2 == slider.$SlidesCount() - 1) {
                      slider.$PlayTo(slider.$SlidesCount() - 2);
                  }

                  $('input[name=' + radioName + ']').each(function (index) {
                      if (index + 1 == slideIndex2) {
                          $(this).prop("checked", true);
                      } else {
                          $(this).prop("checked", false);
                      }
                  });

              });

              /*#region responsive code begin*/

              var MAX_WIDTH = 980;

              function ScaleSlider() {
                  var containerElement = slider.$Elmt.parentNode;
                  var containerWidth = containerElement.clientWidth;

                  if (containerWidth) {
                      var expectedWidth = Math.min(MAX_WIDTH || containerWidth, containerWidth);
                      slider.$ScaleWidth(expectedWidth);
                  } else {
                      window.setTimeout(ScaleSlider, 30);
                  }
              }

              ScaleSlider();

              $Jssor$.$AddEvent(window, "load", ScaleSlider);
              $Jssor$.$AddEvent(window, "resize", ScaleSlider);
              $Jssor$.$AddEvent(window, "orientationchange", ScaleSlider);
              /*#endregion responsive code end*/
          };
          jssor_1_slider_init();
      }


      $(window).resize(function () {
          displayRadioBar();
      });

      function displayRadioBar() {
          setTimeout(function () {
              radioBarPositioning(".pregnancy-stage");
          }, 1000);
      }

      function radioBarPositioning(selector) {
          let firstRadioPos = $(selector).find(".fit-first-radio").offset();
          let newLeft = firstRadioPos.left + 7;
          let lastRadioPos = $(selector).find(".fit-last-radio").offset();
          let newWidth = (lastRadioPos.left - newLeft) + 3;
          let newTop = firstRadioPos.top + 7;
          $(selector).find(".fit-bar").css({top: newTop, left: newLeft, width: newWidth});
      }

      $('.size-quiz-bottoms .carousel').carousel('pause');

      $('input').on('input', function () {
          if ($('input[name=bottom_size]:checked').val()) {
              $('#slide2-btn').prop('disabled', false);
          }
          if ($('input[name=height]:checked').val()) {
              $('#slide3-btn').prop('disabled', false);
          }
          if ($('input[name=stage]:checked').val()) {
              $('#slide4-btn').prop('disabled', false);
          }
          if ($('#email').is(':valid')) {
              $('#slide5-btn').prop('disabled', false);
          }
      });

      $('.size-quiz-bottoms .back-btn').on('click', function () {
          $('.carousel').carousel('prev');
          displayRadioBar();
      });

      $('.size-quiz-bottoms .next-btn').on('click', function () {
          $('.carousel').carousel('next');
          displayRadioBar();
      });

      function getAnswers() {
          let stages = ['1st Trimester', '2nd Trimester', '3rd Trimester', 'Postpartum', 'Neither'];

          return {
              'bottom': $('input[name=bottom_size]:checked').val(),
              'height': $('input[name=height]:checked').val(),
              'email': $('#email').val(),
              'stage': stages[$('input[name=stage]:checked').val()]
          };
      }

      $('.size-quiz-bottoms #slide5-btn').on('click', function () {
          let answers = getAnswers();
          updateUrl(answers);
  		fbq('track', 'Lead');

          _learnq.push(['identify', {
              '$email': answers.email,
              'Pregnancy Stage': answers.stage,
              'Height': answers.height,
              'Bottom Size': answers.bottom
          }]);

  		_learnq.push(['track', 'Bottoms Quiz', {
              'items': klavyoItems
          }]);

      });

      $('.size-quiz-bottoms #not-now-btn').on('click', function () {
          updateUrl(getAnswers());
      });

      $('.size-quiz-bottoms #restart-quiz').click(function(e) {
  		e.preventDefault();
  		localStorage.removeItem("quiz-results-bottoms");
  		window.location = '/pages/size-quiz-bottoms';
  	});

      function updateUrl(answers) {
          let queryString = $.param(answers);
          window.history.pushState(" ", "Quiz Results", "?" + queryString);
  		localStorage.setItem("quiz-results-bottoms", queryString);
      }

      $(document).ready(function() {
          let queryVars = getUrlVars();
          if (queryVars.bottom) {
              loadProducts(queryVars);
              $('.size-quiz-bottoms .carousel').carousel(5);
          }
      });

      function getUrlVars() {
          var vars = [], hash;
          var hashes = [];
  		if (window.location.href.indexOf('?') > 0) {
  			hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  		} else if (localStorage.getItem("quiz-results-bottoms")) {
  			hashes = localStorage.getItem("quiz-results-bottoms").split('&');
  		}
  		for(var i = 0; i < hashes.length; i++)
          {
              hash = hashes[i].split('=');
              vars.push(hash[0]);
              vars[hash[0]] = decodeURI(hash[1]);
          }

          return vars;
      }


      $('.size-quiz-bottoms #slide4-btn').on('click', function () {
          loadProducts(getAnswers());
      });

      $('.size-quiz-bottoms #slide4-btn-2').on('click', function () {
          loadProducts(getAnswers());
      });

      function loadProducts(answers) {
          let bottomSizes = {'6': 'XS', '8': 'XS', '10': 'S', '12': 'M', '14': 'L', '16': 'XL', '18': ('XXL','2XL'), '20': '3XL'};
  		let stages = {'1st Trimester': 'P', '2nd Trimester': 'P', '3rd Trimester': 'P', 'Postpartum': 'NP', 'Neither': 'NP'};


          $.each(bottomMatrix[answers.bottom][answers.height][stages[answers.stage]], function(index,item) {
              let parts = item.split(' ');
              let productHandle = parts[0];
              let size = parts[1];
              allProductsLoader(function(allProducts) {
  		      let product = allProducts[productHandle];
                if (product) {
                  displayLoadedProduct(product, size, allProducts);
                }
              });
          });

      }

      let klavyoItems = [];
      function displayLoadedProduct(item, size, allProducts) {
          let product = item;
          let variantId = '';
          let available = false;
          product.variants.forEach(function (variant, key) {
              if (variant.title == 'XS' && size == 'XS') {
                  variantId = variant.id;
                  available = variant.available;
              } else if (variant.title == 'S' && size == 'S') {
                  variantId = variant.id;
                  available = variant.available;
              } else if (variant.title == 'M' && size == 'M') {
                  variantId = variant.id;
                  available = variant.available;
              } else if (variant.title == 'L' && size == 'L') {
                  variantId = variant.id;
                  available = variant.available;
              } else if (variant.title == 'XL' && size == 'XL') {
                  variantId = variant.id;
                  available = variant.available;
              } else if (variant.title == 'XXL' && size == 'XXL') {
                  variantId = variant.id;
                  available = variant.available;
              } else if (variant.title == '2XL' && size == '2XL') {
                  variantId = variant.id;
                  available = variant.available;
              } else if (variant.title == '3XL' && size == '3XL') {
                  variantId = variant.id;
                  available = variant.available;
              }
          });

          let klavyoProduct = product;
          klavyoProduct.selectedSize = size;
          klavyoProduct.selectedVariant = variantId;
          klavyoProduct.selectedVariantAvailable = available;
          klavyoProduct.description = '';
          klavyoItems.push(klavyoProduct);

              let sizeWidths = Object.keys(product.images[0].sizes).reverse();
              let sizes = Object.values(product.images[0].sizes).reverse();
              let imagesHtml = '';
              $.each(sizes,function(key,imgsize) {
                if (key >= sizes.length-2) {
                  return;
                }
                imagesHtml += '<source media="(min-width: '+sizeWidths[key+1]+'px)" srcset="'+imgsize+'">';
             });

          product.price = $('.size-quiz-bottoms').attr('data-price-format').replace('0.00', (product.price/100).toFixed(2));
          colourHtml = '';
          $.each(product.colour_group,function(key,handle) {
            if (allProducts.hasOwnProperty(handle) && allProducts[handle].online) {
              colourHtml += '<a href="/products/'+handle+'" data-handle="'+handle+'" class="colour-picker rounded-circle mr-2 '+ (handle == product.handle ? 'border' : '')+'">'+
                  '<img class="rounded-circle alt-colour" src="'+allProducts[handle].swatch+'" alt="Alternate Colours">'+
                '</a>';
            }
          });


          let template = '<div class="col col-9 col-md-4 product-col">' +
              '<div class="container grid-item pb-0">' +
                '<div class="main-image-frame position-relative">' +
                  '<a href="/products/' + product.handle + '?variant=' + variantId + '">' +
  				  '<picture class="main-image">'+
                      imagesHtml+
                      '<img class="img-fluid" src="'+product.images[0].sizes[105]+'" alt="'+product.images[0].alt+'">'+
                    '</picture>'+
  '<span class="d-md-none plus-symbol" data-handle="'+product.handle+'" data-varaint-id="'+variantId+'" data-toggle="modal" data-target="#other-product-modal">+</span>'+
  '<div class="position-absolute quick-view-button-wrapper d-flex justify-content-center">'+
            '<button class="quick-view-button d-none d-md-block" type="button" data-varaint-id="'+variantId+'" data-handle="'+product.handle+'" data-toggle="modal" data-target="#other-product-modal">+ Quick View</button>'+
            '</div>'+
  		   '</a>' +
                '</div>' +
                '<div class="row details">' +
                  '<div class="col py-2 text-center">' +
                    '<span class="no-wrap d-block"><a href="/products/' + product.handle + '?variant=' + variantId + '">' +
  					product.title.replace(product.colour,'') + '</a></span>' +
                    '<span class="price mb-2">' + product.price + '</span>' +

  				'<div class="colour-pickers" data-handle="'+product.handle+'">'+
                    colourHtml+
                  '</div>'+
  				(available ?
  				'<button class="btn add-to-cart" data-handle="'+product.handle+'" data-variant-title="'+size+'" data-variant-id="'+variantId+'" data-product-title="'+product.title+'" data-image-url="'+product.images[0].sizes['105']+'" data-price="'+product.price+'">'+
  					'Size ' + size + ' - Add to cart</button>'
  				: 'Size ' + size + ' - Out of stock')+
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>';

          $('#product-results').append(template);
  		addQuickViewEvent();
      }

    function addQuickViewEvent() {
      $('#quiz-slider-bottoms').find('.quick-view-button').click(function(e) {
        e.preventDefault();
      });

      $('.size-quiz-bottoms .main-image-frame').off('hover');
      $('.size-quiz-bottoms .main-image-frame').hover(function(){
        $(this).find('.quick-view-button').addClass('hovered');
      },function(){
        $(this).find('.quick-view-button').removeClass('hovered');
      });

      $('#quiz-slider-bottoms .plus-symbol').off('click');
      $('#quiz-slider-bottoms .plus-symbol').click(function(e){e.preventDefault();});

      $('#quiz-slider-bottoms .add-to-cart').off('click');
      $('#quiz-slider-bottoms .add-to-cart').click(function(){
        addToSideCart($(this).attr('data-variant-id'),$(this).attr('data-price'),$(this).attr('data-image-url'),$(this).attr('data-product-title'),$(this).attr('data-variant-title'),$(this).attr('data-handle'));
        showSideCart();
      });
    }


      let bottomMatrix = {
          "6": {
              "low": {
                  "P": [
                      "postpartum-tights-cruiser-ryan-ribbed-black XS",
                      "pregnancy-leggings-7-8-length-pockets-black XS",
                      "maternity-leggings-3-4-pockets-black XS",
                      "maternity-leggings-with-pockets-classic-full-length-black XS",
                      "ryan-ribbed-maternity-leggings-7-8-navy XS",
                      "high-waisted-bike-shorts-pockets-black XS",
                      "postpartum-high-waisted-running-shorts-swift-black XS",
                      "high-waisted-boyleg-underwear-relax-short-black XS",
                      "maternity-harem-pants-cosy-me XS",
                      "maternity-bamboo-jogger-navy XS",
                      "womens-casual-shorts-sunday-shorts-grey-marle XS"
                  ],
                  "NP": [
                     "maya-high-waisted-tights-sakura XS",
                      "postpartum-tights-cruiser-ryan-ribbed-black XS",
                      "postpartum-high-waisted-running-shorts-swift-black XS",
                      "high-waisted-boyleg-underwear-relax-short-black XS",
                      "maternity-harem-pants-cosy-me XS",
                      "maternity-bamboo-jogger-navy XS",
                      "womens-casual-shorts-sunday-shorts-grey-marle XS"
                  ]
              },
              "high": {
                  "P": [
                     "maya-high-waisted-tights-sakura XS",
                      "postpartum-tights-cruiser-ryan-ribbed-black XS",
                      "pregnancy-leggings-7-8-length-pockets-black XS",
                      "maternity-leggings-3-4-pockets-black XS",
                      "maternity-leggings-with-pockets-classic-full-length-black XS",
                      "ryan-ribbed-maternity-leggings-7-8-navy XS",
                      "high-waisted-bike-shorts-pockets-black XS",
                      "postpartum-high-waisted-running-shorts-swift-black XS",
                      "high-waisted-boyleg-underwear-relax-short-black XS",
                      "maternity-harem-pants-cosy-me XS",
                      "maternity-bamboo-jogger-navy XS",
                      "womens-casual-shorts-sunday-shorts-grey-marle XS"
                  ],
                  "NP": [
                     "maya-high-waisted-tights-sakura XS",
                      "postpartum-tights-cruiser-ryan-ribbed-black XS",
                      "postpartum-high-waisted-running-shorts-swift-black XS",
                      "high-waisted-boyleg-underwear-relax-short-black XS",
                      "maternity-harem-pants-cosy-me XS",
                      "maternity-bamboo-jogger-navy XS",
                      "womens-casual-shorts-sunday-shorts-grey-marle XS"
                  ]
              }
          },
          "8": {
              "low": {
                  "P": [
                       "maya-high-waisted-tights-sakura XS",
                      "postpartum-tights-cruiser-ryan-ribbed-black XS",
                      "pregnancy-leggings-7-8-length-pockets-black XS",
                      "maternity-leggings-3-4-pockets-black XS",
                      "maternity-leggings-with-pockets-classic-full-length-black XS",
                      "ryan-ribbed-maternity-leggings-7-8-navy XS",
                      "high-waisted-bike-shorts-pockets-black XS",
                      "postpartum-high-waisted-running-shorts-swift-black XS",
                      "high-waisted-boyleg-underwear-relax-short-black XS",
                      "maternity-harem-pants-cosy-me XS",
                      "maternity-bamboo-jogger-navy XS",
                      "womens-casual-shorts-sunday-shorts-grey-marle XS"
                  ],
                  "NP": [
                     "maya-high-waisted-tights-sakura XS",
                      "postpartum-tights-cruiser-ryan-ribbed-black XS",
                      "postpartum-high-waisted-running-shorts-swift-black XS",
                      "high-waisted-boyleg-underwear-relax-short-black XS",
                      "maternity-harem-pants-cosy-me XS",
                      "womens-casual-shorts-sunday-shorts-grey-marle XS"
                      ]
              },
              "high": {
                  "P": [
                       "maya-high-waisted-tights-sakura XS",
                      "postpartum-tights-cruiser-ryan-ribbed-black XS",
                      "pregnancy-leggings-7-8-length-pockets-black XS",
                      "maternity-leggings-3-4-pockets-black XS",
                      "maternity-leggings-with-pockets-classic-full-length-black XS",
                      "ryan-ribbed-maternity-leggings-7-8-navy XS",
                      "high-waisted-bike-shorts-pockets-black XS",
                      "postpartum-high-waisted-running-shorts-swift-black XS",
                      "high-waisted-boyleg-underwear-relax-short-black XS",
                      "maternity-harem-pants-cosy-me XS",
                      "maternity-bamboo-jogger-navy XS",
                      "womens-casual-shorts-sunday-shorts-grey-marle XS"
                  ],
                  "NP": [
                     "maya-high-waisted-tights-sakura XS",
                      "postpartum-tights-cruiser-ryan-ribbed-black XS",
                      "postpartum-high-waisted-running-shorts-swift-black XS",
                      "high-waisted-boyleg-underwear-relax-short-black XS",
                      "maternity-harem-pants-cosy-me XS",
                      "maternity-bamboo-jogger-navy XS",
                      "womens-casual-shorts-sunday-shorts-grey-marle XS"
                  ]
              }
          },
          "10":{
              "low":{
                  "P":[
                      "maya-high-waisted-tights-sakura S",
                      "postpartum-tights-cruiser-ryan-ribbed-black S",
                      "pregnancy-leggings-7-8-length-pockets-black S",
                      "maternity-leggings-3-4-pockets-black S",
                      "maternity-leggings-with-pockets-classic-full-length-black S",
                      "ryan-ribbed-maternity-leggings-7-8-navy S",
                      "high-waisted-bike-shorts-pockets-black S",
                      "postpartum-high-waisted-running-shorts-swift-black S",
                      "high-waisted-boyleg-underwear-relax-short-black S",
                      "maternity-harem-pants-cosy-me S",
                      "maternity-bamboo-jogger-navy S",
                      "womens-casual-shorts-sunday-shorts-grey-marle S"
                  ],
                  "NP":[
                      "maya-high-waisted-tights-sakura S",
                      "postpartum-tights-cruiser-ryan-ribbed-black S",
                      "postpartum-high-waisted-running-shorts-swift-black S",
                      "high-waisted-boyleg-underwear-relax-short-black S",
                      "maternity-harem-pants-cosy-me S",
                      "maternity-bamboo-jogger-navy S",
                      "maternity-nursing-short-sleeve-dress-grey S",
                      "womens-casual-shorts-sunday-shorts-grey-marle S"
                  ]
              },
              "high":{
                  "P":[
                      "maya-high-waisted-tights-sakura S",
                      "postpartum-tights-cruiser-ryan-ribbed-black S",
                      "pregnancy-leggings-7-8-length-pockets-black S",
                      "maternity-leggings-3-4-pockets-black S",
                      "maternity-leggings-with-pockets-classic-full-length-black S",
                      "ryan-ribbed-maternity-leggings-7-8-navy S",
                      "high-waisted-bike-shorts-pockets-black S",
                      "postpartum-high-waisted-running-shorts-swift-black S",
                      "high-waisted-boyleg-underwear-relax-short-black S",
                      "maternity-harem-pants-cosy-me S",
                      "maternity-bamboo-jogger-navy S",
                      "womens-casual-shorts-sunday-shorts-grey-marle S"
                  ],
                  "NP":[
                      "maya-high-waisted-tights-sakura S",
                      "postpartum-tights-cruiser-ryan-ribbed-black S",
                      "postpartum-high-waisted-running-shorts-swift-black S",
                      "high-waisted-boyleg-underwear-relax-short-black S",
                      "maternity-harem-pants-cosy-me S",
                      "maternity-bamboo-jogger-navy S",
                      "womens-casual-shorts-sunday-shorts-grey-marle S"
                  ]
              }
          },
          "12":{
              "low":{
                  "P":[
                      "maya-high-waisted-tights-sakura M",
                      "postpartum-tights-cruiser-ryan-ribbed-black M",
                      "pregnancy-leggings-7-8-length-pockets-black M",
                      "maternity-leggings-3-4-pockets-black M",
                      "maternity-leggings-with-pockets-classic-full-length-black M",
                      "ryan-ribbed-maternity-leggings-7-8-navy M",
                      "high-waisted-bike-shorts-pockets-black M",
                      "postpartum-high-waisted-running-shorts-swift-black M",
                      "high-waisted-boyleg-underwear-relax-short-black M",
                      "maternity-harem-pants-cosy-me M",
                      "maternity-bamboo-jogger-navy M",
                      "womens-casual-shorts-sunday-shorts-grey-marle M"
                  ],
                  "NP":[
                      "maya-high-waisted-tights-sakura M",
                      "postpartum-tights-cruiser-ryan-ribbed-black M",
                      "postpartum-high-waisted-running-shorts-swift-black M",
                      "high-waisted-boyleg-underwear-relax-short-black M",
                      "maternity-harem-pants-cosy-me M",
                      "maternity-bamboo-jogger-navy M",
                      "womens-casual-shorts-sunday-shorts-grey-marle M"

                  ]
              },
              "high":{
                  "P":[
                      "maya-high-waisted-tights-sakura M",
                      "postpartum-tights-cruiser-ryan-ribbed-black M",
                      "pregnancy-leggings-7-8-length-pockets-black M",
                      "maternity-leggings-3-4-pockets-black M",
                      "maternity-leggings-with-pockets-classic-full-length-black M",
                      "ryan-ribbed-maternity-leggings-7-8-navy M",
                      "high-waisted-bike-shorts-pockets-black M",
                      "postpartum-high-waisted-running-shorts-swift-black M",
                      "high-waisted-boyleg-underwear-relax-short-black M",
                      "maternity-harem-pants-cosy-me M",
                      "maternity-bamboo-jogger-navy M",
                      "womens-casual-shorts-sunday-shorts-grey-marle M"

                  ],
                  "NP":[
                      "maya-high-waisted-tights-sakura M",
                      "postpartum-tights-cruiser-ryan-ribbed-black M",
                      "postpartum-high-waisted-running-shorts-swift-black M",
                      "high-waisted-boyleg-underwear-relax-short-black M",
                      "maternity-harem-pants-cosy-me M",
                      "maternity-bamboo-jogger-navy M",
                      "womens-casual-shorts-sunday-shorts-grey-marle M"
                  ]
              }
          },
          "14":{
              "low":{
                  "P":[
                      "maya-high-waisted-tights-sakura L",
                      "postpartum-tights-cruiser-ryan-ribbed-black L",
                      "pregnancy-leggings-7-8-length-pockets-black L",
                      "maternity-leggings-3-4-pockets-black L",
                      "maternity-leggings-with-pockets-classic-full-length-black L",
                      "ryan-ribbed-maternity-leggings-7-8-navy L",
                      "high-waisted-bike-shorts-pockets-black L",
                      "postpartum-high-waisted-running-shorts-swift-black L",
                      "high-waisted-boyleg-underwear-relax-short-black L",
                      "maternity-harem-pants-cosy-me L",
                      "maternity-bamboo-jogger-navy L",
                      "womens-casual-shorts-sunday-shorts-grey-marle L"
                  ],
                  "NP":[
                      "maya-high-waisted-tights-sakura L",
                      "postpartum-tights-cruiser-ryan-ribbed-black L",
                      "postpartum-high-waisted-running-shorts-swift-black L",
                      "high-waisted-boyleg-underwear-relax-short-black L",
                      "maternity-harem-pants-cosy-me L",
                      "maternity-bamboo-jogger-navy L"
                  ]
              },
              "high":{
                  "P":[
                      "maya-high-waisted-tights-sakura L",
                      "postpartum-tights-cruiser-ryan-ribbed-black L",
                      "pregnancy-leggings-7-8-length-pockets-black L",
                      "maternity-leggings-3-4-pockets-black L",
                      "maternity-leggings-with-pockets-classic-full-length-black L",
                      "ryan-ribbed-maternity-leggings-7-8-navy L",
                      "high-waisted-bike-shorts-pockets-black L",
                      "postpartum-high-waisted-running-shorts-swift-black L",
                      "high-waisted-boyleg-underwear-relax-short-black L",
                      "maternity-harem-pants-cosy-me L",
                      "maternity-bamboo-jogger-navy L",
                      "womens-casual-shorts-sunday-shorts-grey-marle L"
                  ],
                  "NP":[
                      "maya-high-waisted-tights-sakura L",
                      "postpartum-tights-cruiser-ryan-ribbed-black L",
                      "postpartum-high-waisted-running-shorts-swift-black L",
                      "high-waisted-boyleg-underwear-relax-short-black L",
                      "maternity-harem-pants-cosy-me L",
                      "maternity-bamboo-jogger-navy L",
                      "womens-casual-shorts-sunday-shorts-grey-marle L"
                  ]
              }
          },
          "16":{
              "low":{
                  "P":[
                      "pregnancy-leggings-7-8-length-pockets-black XL",
                      "maternity-leggings-3-4-pockets-black XL",
                      "maternity-leggings-with-pockets-classic-full-length-black XL",
                      "ryan-ribbed-maternity-leggings-7-8-navy XL",
                      "high-waisted-bike-shorts-pockets-black XL",
                      "postpartum-high-waisted-running-shorts-swift-black XL",
                      "high-waisted-boyleg-underwear-relax-short-black XL",
                      "high-waisted-boyleg-underwear-relax-short-black XL",
                      "maternity-harem-pants-cosy-me XL",
                      "maternity-bamboo-jogger-navy XL",
                      "womens-casual-shorts-sunday-shorts-grey-marle XL"
                  ],
                  "NP":[
                      "maya-high-waisted-tights-sakura XL",
                      "postpartum-tights-cruiser-ryan-ribbed-black XL",
                      "postpartum-high-waisted-running-shorts-swift-black XL",
                      "high-waisted-boyleg-underwear-relax-short-black XL",
                      "maternity-harem-pants-cosy-me XL",
                      "maternity-bamboo-jogger-navy XL",
                      "womens-casual-shorts-sunday-shorts-grey-marle XL"
                  ]
              },
              "high":{
                  "P":[

                      "pregnancy-leggings-7-8-length-pockets-black XL",
                      "maternity-leggings-3-4-pockets-black XL",
                      "maternity-leggings-with-pockets-classic-full-length-black XL",
                      "ryan-ribbed-maternity-leggings-7-8-navy XL",
                      "high-waisted-bike-shorts-pockets-black XL",
                      "postpartum-high-waisted-running-shorts-swift-black XL",
                      "high-waisted-boyleg-underwear-relax-short-black XL",
                      "maternity-harem-pants-cosy-me XL",
                      "maternity-bamboo-jogger-navy XL",
                      "womens-casual-shorts-sunday-shorts-grey-marle XL"
                  ],
                  "NP":[
                      "maya-high-waisted-tights-sakura XL",
                      "postpartum-tights-cruiser-ryan-ribbed-black XL",
                      "postpartum-high-waisted-running-shorts-swift-black XL",
                      "high-waisted-boyleg-underwear-relax-short-black XL",
                      "maternity-harem-pants-cosy-me XL",
                      "maternity-bamboo-jogger-navy XL",
                      "maternity-nursing-short-sleeve-dress-grey XL",
                      "womens-casual-shorts-sunday-shorts-grey-marle XL"
                  ]
              }
          },
          "18":{
              "low":{
                  "P":[
                     "pregnancy-leggings-7-8-length-pockets-black 2XL",
                      "maternity-leggings-3-4-pockets-black 2XL",
                      "maternity-leggings-with-pockets-classic-full-length-black 2XL",
                      "ryan-ribbed-maternity-leggings-7-8-navy 2XL",
                      "high-waisted-bike-shorts-pockets-black 2XL",
                      "postpartum-high-waisted-running-shorts-swift-black 2XL",
                      "high-waisted-boyleg-underwear-relax-short-black 2XL",
                      "cadenshae-midi-brief-mint 2XL",
                      "maternity-harem-pants-cosy-me XXL",
                      "maternity-bamboo-jogger-navy 2XL",
                      "womens-casual-shorts-sunday-shorts-grey-marle 2XL"
                  ],
                  "NP":[
                     "maya-high-waisted-tights-sakura 2XL",
                      "postpartum-tights-cruiser-ryan-ribbed-black 2XL",
                      "postpartum-high-waisted-running-shorts-swift-black 2XL",
                      "high-waisted-boyleg-underwear-relax-short-black 2XL",
                      "maternity-harem-pants-cosy-me XXL",
                      "maternity-bamboo-jogger-navy 2XL",
                      "maternity-nursing-short-sleeve-dress-grey 2XL",
                      "womens-casual-shorts-sunday-shorts-grey-marle 2XL"
                  ]
              },
              "high":{
                  "P":[
                     "pregnancy-leggings-7-8-length-pockets-black 2XL",
                      "maternity-leggings-3-4-pockets-black 2XL",
                      "maternity-leggings-with-pockets-classic-full-length-black 2XL",
                      "ryan-ribbed-maternity-leggings-7-8-navy 2XL",
                      "high-waisted-bike-shorts-pockets-black 2XL",
                      "postpartum-high-waisted-running-shorts-swift-black 2XL",
                      "high-waisted-boyleg-underwear-relax-short-black 2XL",
                      "maternity-harem-pants-cosy-me XXL",
                      "maternity-bamboo-jogger-navy 2XL",
                      "womens-casual-shorts-sunday-shorts-grey-marle 2XL"
                  ],
                  "NP":[
                     "maya-high-waisted-tights-sakura 2XL",
                      "postpartum-tights-cruiser-ryan-ribbed-black 2XL",
                      "postpartum-high-waisted-running-shorts-swift-black 2XL",
                      "high-waisted-boyleg-underwear-relax-short-black 2XL",
                      "maternity-harem-pants-cosy-me XXL",
                      "maternity-bamboo-jogger-navy 2XL",
                      "womens-casual-shorts-sunday-shorts-grey-marle 2XL"
                  ]
              }
          },
          "20":{
              "low":{
                  "P":[
                      "pregnancy-leggings-7-8-length-pockets-black 3XL",
                      "maternity-leggings-3-4-pockets-black 3XL",
                      "maternity-leggings-with-pockets-classic-full-length-black 3XL",
                      "ryan-ribbed-maternity-leggings-7-8-navy 3XL",
                      "high-waisted-bike-shorts-pockets-black 3XL",
                      "high-waisted-boyleg-underwear-relax-short-black 3XL",
                      "maternity-harem-pants-cosy-me 3XL",
                      "maternity-bamboo-jogger-navy 3XL",
                      "womens-casual-shorts-sunday-shorts-grey-marle 3XL"
                  ],
                  "NP":[
                        "maya-high-waisted-tights-sakura 3XL",
                      "postpartum-tights-cruiser-ryan-ribbed-black 3XL",
                      "postpartum-high-waisted-running-shorts-swift-black 3XL",
                      "high-waisted-boyleg-underwear-relax-short-black 3XL",
                      "maternity-harem-pants-cosy-me 3XL",
                      "maternity-bamboo-jogger-navy 3XL",
                      "womens-casual-shorts-sunday-shorts-grey-marle 3XL"
                  ]
              },
              "high":{
                  "P":[
                       "pregnancy-leggings-7-8-length-pockets-black 3XL",
                      "maternity-leggings-3-4-pockets-black 3XL",
                      "maternity-leggings-with-pockets-classic-full-length-black 3XL",
                      "ryan-ribbed-maternity-leggings-7-8-navy 3XL",
                      "high-waisted-bike-shorts-pockets-black 3XL",
                      "high-waisted-boyleg-underwear-relax-short-black 3XL",
                      "maternity-harem-pants-cosy-me 3XL",
                      "maternity-bamboo-jogger-navy 3XL",
                      "womens-casual-shorts-sunday-shorts-grey-marle 3XL"
                  ],
                  "NP":[
                        "maya-high-waisted-tights-sakura 3XL",
                      "postpartum-tights-cruiser-ryan-ribbed-black 3XL",
                      "postpartum-high-waisted-running-shorts-swift-black 3XL",
                      "high-waisted-boyleg-underwear-relax-short-black 3XL",
                      "maternity-harem-pants-cosy-me 3XL",
                      "maternity-bamboo-jogger-navy 3XL",
                      "womens-casual-shorts-sunday-shorts-grey-marle 3XL"
                  ]
              }
          }
      };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-quiz-tops"]) return;
  try {
    
  let sizeLinks = [
    {size:6,cupC:80,cupD:85},
    {size:8,cupC:85,cupD:91},
    {size:10,cupC:91,cupD:96},
    {size:12,cupC:96,cupD:101},
    {size:14,cupC:101,cupD:106},
    {size:16,cupC:106,cupD:111},
    {size:18,cupC:111,cupD:116},
    {size:20,cupC:121,cupD:121},
    {size:22,cupC:121,cupD:121}
  ];

  $('.size-clickable').click(function(){
    let selectedBust = $('input[name="bust_size"]:checked').val();
    let selectedTop = $('input[name="top_size"]:checked').val();

    sizeLinks.every(function(link) {
      if (link.size == selectedTop) {
        if (link.cupC != selectedBust && link.cupD != selectedBust) {
          $("input[name=bust_size][value=" + link.cupC + "]").prop('checked', true);
          return false;
        }
      }
      return true;
    });

  });

  $('.bust-clickable').click(function(){
    let selectedBust = $('input[name="bust_size"]:checked').val();
    let selectedTop = $('input[name="top_size"]:checked').val();

    sizeLinks.every(function(link) {
      if (link.size == selectedTop || !selectedTop) {
        if (link.cupC != selectedBust && link.cupD != selectedBust) {
          sizeLinks.every(function(link) {
  			if (link.cupC == selectedBust || link.cupD == selectedBust) {
  				$("input[name=top_size][value=" + link.size + "]").prop('checked', true);
  				return false;
  			}
  			return true;
  		});

          return false;
        }
      }
      return true;
    });

  });


  $('.cup-clickable').click(function() {
    let selectedCup = $('input[name="cup_size"]:checked').val();
    let selectedBust = $('input[name="bust_size"]:checked').val();
    let selectedTop = $('input[name="top_size"]:checked').val();

    sizeLinks.every(function(link){
      if (['A','B','C'].includes(selectedCup)) {
        if (link.cupC == selectedBust) {
          $('[name="top_size"]').removeAttr('checked');
          $("input[name=top_size][value=" + link.size + "]").prop('checked', true);
          return false;
        }
      } else {
        if (link.cupD == selectedBust) {
          $('[name="top_size"]').removeAttr('checked');
          $("input[name=top_size][value=" + link.size + "]").prop('checked', true);
          return false;
        }
      }
      return true;
    });

  });




      $('.size-quiz-tops .start-btn').on('click', function () {
          setTimeout(function () {
              $('.mobile-scroll').scrollLeft(60);
          }, 10);
      });


      $('.size-quiz-tops #slide3-btn-2').on('click', function () {
          if (!$('input[name=stage]:checked').val()) {
              $('input[name=stage]').eq(1).prop("checked", true);
          }
      });


      let stages = ['1st Trimester', '1st Trimester', '2nd Trimester', '3rd Trimester', 'Postpartum', 'Neither, just love Cadenshae!', 'Neither, just love Cadenshae!'];
      addMobileSlider("jssor_bt_1", stages, '.pregnancy-stage', 550, 'stage');



      function addMobileSlider(elementId, selectionTexts, parentSelector, slideWidth, radioName) {
          window.jssor_1_slider_init = function () {

              var slider_options = {
                  $AutoPlay: 0,
                  $SlideWidth: slideWidth,
                  $Loop: 0,
                  $StartIndex: 2
              };

              var slider = new $JssorSlider$(elementId, slider_options);

              slider.$On($JssorSlider$.$EVT_PARK, function (slideIndex, fromIndex) {
                  var slideIndex2 = Math.round(slider.$CurrentPosition());
                  $(parentSelector).find('.slider-text').text(selectionTexts[slideIndex2]);

                  if (slideIndex2 == 0) {
                      slider.$PlayTo(1);
                  }
                  if (slideIndex2 == slider.$SlidesCount() - 1) {
                      slider.$PlayTo(slider.$SlidesCount() - 2);
                  }

                  $('input[name=' + radioName + ']').each(function (index) {
                      if (index + 1 == slideIndex2) {
                          $(this).prop("checked", true);
                      } else {
                          $(this).prop("checked", false);
                      }
                  });

              });

              /*#region responsive code begin*/

              var MAX_WIDTH = 980;

              function ScaleSlider() {
                  var containerElement = slider.$Elmt.parentNode;
                  var containerWidth = containerElement.clientWidth;

                  if (containerWidth) {
                      var expectedWidth = Math.min(MAX_WIDTH || containerWidth, containerWidth);
                      slider.$ScaleWidth(expectedWidth);
                  } else {
                      window.setTimeout(ScaleSlider, 30);
                  }
              }

              ScaleSlider();

              $Jssor$.$AddEvent(window, "load", ScaleSlider);
              $Jssor$.$AddEvent(window, "resize", ScaleSlider);
              $Jssor$.$AddEvent(window, "orientationchange", ScaleSlider);
              /*#endregion responsive code end*/
          };
          jssor_1_slider_init();
      }


      $(window).resize(function () {
          displayRadioBar();
      });

      function displayRadioBar() {
          setTimeout(function () {
              radioBarPositioning(".pregnancy-stage");
          }, 1000);
      }

      function radioBarPositioning(selector) {
          let firstRadioPos = $(selector).find(".fit-first-radio").offset();
          let newLeft = firstRadioPos.left + 7;
          let lastRadioPos = $(selector).find(".fit-last-radio").offset();
          let newWidth = (lastRadioPos.left - newLeft) + 3;
          let newTop = firstRadioPos.top + 7;
          $(selector).find(".fit-bar").css({top: newTop, left: newLeft, width: newWidth});
      }

      $('.size-quiz-tops .carousel').carousel('pause');

      $('input').on('input', function () {
  		if ($('input[name=top_size]:checked').val()) {
              $('#slide2-btn').prop('disabled', false);
          }
          if ($('input[name=cup_size]:checked').val()) {
              $('#slide3-btn').prop('disabled', false);
          }
          if ($('input[name=stage]:checked').val()) {
              $('#slide4-btn').prop('disabled', false);
          }
          if ($('#email').is(':valid')) {
              $('#slide5-btn').prop('disabled', false);
          }
      });

      $('.size-quiz-tops .back-btn').on('click', function () {
          $('.carousel').carousel('prev');
          displayRadioBar();
      });

      $('.size-quiz-tops .next-btn').on('click', function () {
          $('.carousel').carousel('next');
          displayRadioBar();
      });

      function getAnswers() {
          let stages = ['1st Trimester', '2nd Trimester', '3rd Trimester', 'Postpartum', 'Neither'];

          return {
              'top': $('input[name=top_size]:checked').val(),
              'cup': $('input[name=cup_size]:checked').val(),
  			'bust': $('input[name=bust_size]:checked').val(),
              'email': $('#email').val(),
              'stage': stages[$('input[name=stage]:checked').val()]
          };
      }

      $('.size-quiz-tops #slide5-btn').on('click', function () {
          let answers = getAnswers();
          updateUrl(answers);
  		fbq('track', 'Lead');

          _learnq.push(['identify', {
              '$email': answers.email,
              'Pregnancy Stage': answers.stage,
              'Cup Size': answers.cup,
  			'Bust Size': answers.bust,
              'Top Size': answers.top
          }]);

  		_learnq.push(['track', 'Tops Quiz', {
              'items': klavyoItems
          }]);

      });

      $('.size-quiz-tops #not-now-btn').on('click', function () {
          updateUrl(getAnswers());
      });

      $('.size-quiz-tops #restart-quiz').click(function(e) {
  		e.preventDefault();
  		localStorage.removeItem("quiz-results-tops");
  		window.location = '/pages/size-quiz-tops';
  	});

      function updateUrl(answers) {
          let queryString = $.param(answers);
          window.history.pushState(" ", "Quiz Results", "?" + queryString);
  		localStorage.setItem("quiz-results-tops", queryString);
      }

      $(document).ready(function() {
          let queryVars = getUrlVars();
          if (queryVars.top) {
              loadProducts(queryVars);
              $('.size-quiz-tops .carousel').carousel(5);
          }
      });

      function getUrlVars() {
          var vars = [], hash;
          var hashes = [];
  		if (window.location.href.indexOf('?') > 0) {
  			hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  		} else if (localStorage.getItem("quiz-results-tops")) {
  			hashes = localStorage.getItem("quiz-results-tops").split('&');
  		}
  		for(var i = 0; i < hashes.length; i++)
          {
              hash = hashes[i].split('=');
              vars.push(hash[0]);
              vars[hash[0]] = decodeURI(hash[1]);
          }

          return vars;
      }

      $('.size-quiz-tops #slide4-btn').on('click', function () {
          loadProducts(getAnswers());
      });

      $('.size-quiz-tops #slide4-btn-2').on('click', function () {
          loadProducts(getAnswers());
      });

      function loadProducts(answers) {
          let cup = ['A','B','C'].includes(answers.cup) ? 'C' : 'D';
          console.log(cup+" "+answers.bust);
          $.each(topMatrix[cup][answers.bust], function(index,item) {
              let parts = item.split(' ');
              let productHandle = parts[0];
              let size = parts[1];
              allProductsLoader(function(allProducts) {
  		      let product = allProducts[productHandle];
                if (product) {
                  displayLoadedProduct(product, size, allProducts);
                }
              });
          });
      }

      let klavyoItems = [];
      function displayLoadedProduct(item, size, allProducts) {
          let product = item;
          let variantId = '';
          let available = false;
          product.variants.forEach(function (variant, key) {
              if (variant.title == 'XS' && size == 'XS') {
                  variantId = variant.id;
                  available = variant.available;
              } else if (variant.title == 'S' && size == 'S') {
                  variantId = variant.id;
                  available = variant.available;
              } else if (variant.title == 'M' && size == 'M') {
                  variantId = variant.id;
                  available = variant.available;
              } else if (variant.title == 'L' && size == 'L') {
                  variantId = variant.id;
                  available = variant.available;
              } else if (variant.title == 'XL' && size == 'XL') {
                  variantId = variant.id;
                  available = variant.available;
              } else if (variant.title == 'XXL' && size == 'XXL') {
                  variantId = variant.id;
                  available = variant.available;
              } else if (variant.title == '2XL' && size == '2XL') {
                  variantId = variant.id;
                  available = variant.available;
              } else if (variant.title == '3XL' && size == '3XL') {
                  variantId = variant.id;
                  available = variant.available;
              }
          });

          let klavyoProduct = product;
          klavyoProduct.selectedSize = size;
          klavyoProduct.selectedVariant = variantId;
          klavyoProduct.selectedVariantAvailable = available;
          klavyoProduct.description = '';
          klavyoItems.push(klavyoProduct);

              let sizeWidths = Object.keys(product.images[0].sizes).reverse();
              let sizes = Object.values(product.images[0].sizes).reverse();
              let imagesHtml = '';
              $.each(sizes,function(key,imgsize) {
                if (key >= sizes.length-2) {
                  return;
                }
                imagesHtml += '<source media="(min-width: '+sizeWidths[key+1]+'px)" srcset="'+imgsize+'">';
             });

          product.price = $('.size-quiz-tops').attr('data-price-format').replace('0.00', (product.price/100).toFixed(2));
          colourHtml = '';
          $.each(product.colour_group,function(key,handle) {
            if (allProducts.hasOwnProperty(handle) && allProducts[handle].online) {
              colourHtml += '<a href="/products/'+handle+'" data-handle="'+handle+'" class="colour-picker rounded-circle mr-2 '+ (handle == product.handle ? 'border' : '')+'">'+
                  '<img class="rounded-circle alt-colour" src="'+allProducts[handle].swatch+'" alt="Alternate Colours">'+
                '</a>';
            }
          });


          let template = '<div class="col col-9 col-md-4 product-col">' +
              '<div class="container grid-item pb-0">' +
                '<div class="main-image-frame position-relative">' +
                  '<a href="/products/' + product.handle + '?variant=' + variantId + '">' +
  				  '<picture class="main-image">'+
                      imagesHtml+
                      '<img class="img-fluid" src="'+product.images[0].sizes[105]+'" alt="'+product.images[0].alt+'">'+
                    '</picture>'+
  '<span class="d-md-none plus-symbol" data-handle="'+product.handle+'" data-varaint-id="'+variantId+'" data-toggle="modal" data-target="#other-product-modal">+</span>'+
  '<div class="position-absolute quick-view-button-wrapper d-flex justify-content-center">'+
            '<button class="quick-view-button d-none d-md-block" type="button" data-varaint-id="'+variantId+'" data-handle="'+product.handle+'" data-toggle="modal" data-target="#other-product-modal">+ Quick View</button>'+
            '</div>'+
                  '</a>' +
                '</div>' +
                '<div class="row details">' +
                  '<div class="col py-2 text-center">' +
                    '<span class="no-wrap d-block"><a href="/products/' + product.handle + '?variant=' + variantId + '">' +
  					product.title.replace(product.colour,'') + '</a></span>' +
                    '<span class="price mb-2">' + product.price + '</span>' +

  				'<div class="colour-pickers" data-handle="'+product.handle+'">'+
                    colourHtml+
                  '</div>'+
  				(available ?
  				'<button class="btn add-to-cart" data-handle="'+product.handle+'" data-variant-title="'+size+'" data-variant-id="'+variantId+'" data-product-title="'+product.title+'" data-image-url="'+product.images[0].sizes['105']+'" data-price="'+product.price+'">'+
  					'Size ' + size + ' - Add to cart</button>'
  				: 'Size ' + size + ' - Out of stock')+
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>';

          $('#product-results').append(template);
  		addQuickViewEvent();
      }


    function addQuickViewEvent() {
      $('#quiz-slider-tops').find('.quick-view-button').click(function(e) {
        e.preventDefault();
      });

      $('.size-quiz-tops .main-image-frame').off('hover');
      $('.size-quiz-tops .main-image-frame').hover(function(){
        $(this).find('.quick-view-button').addClass('hovered');
      },function(){
        $(this).find('.quick-view-button').removeClass('hovered');
      });

      $('.size-quiz-tops .plus-symbol').off('click');
      $('.size-quiz-tops .plus-symbol').click(function(e){e.preventDefault();});

      $('.size-quiz-tops .add-to-cart').off('click');
      $('.size-quiz-tops .add-to-cart').click(function(){
        addToSideCart($(this).attr('data-variant-id'),$(this).attr('data-price'),$(this).attr('data-image-url'),$(this).attr('data-product-title'),$(this).attr('data-variant-title'),$(this).attr('data-handle'));
        showSideCart();
      });
    }

      let topMatrix = {
          "C":{
              "80":[
                  "breastfeeding-jumper-jackson-hoodie-dusky-rose XS",
                  "breastfeeding-hoodie-everyday-hoodie-provence-blue XS",
                  "breastfeeding-sweatshirt-jackson-mist-green XS",
                  "breastfeeding-sweatshirt-jackson-black XS",
                  "breastfeeding-t-shirt-charlotte-tee-tie-dye-ocean XS",
                  "maternity-top-deluxe-long-sleeve-black XS",
                  "breastfeeding-tops-casual-tank-black XS",
                  "maternity-tops-bamboo-long-sleeve-tui-blue XS"

              ],
              "85":[
                  "breastfeeding-jumper-jackson-hoodie-dusky-rose XS",
                  "breastfeeding-hoodie-everyday-hoodie-provence-blue XS",
                  "breastfeeding-sweatshirt-jackson-mist-green XS",
                  "breastfeeding-sweatshirt-jackson-black XS",
                  "breastfeeding-t-shirt-charlotte-tee-tie-dye-ocean XS",
                  "maternity-top-deluxe-long-sleeve-black XS",
                  "breastfeeding-tops-casual-tank-black XS"
              ],
              "91":[
                  "breastfeeding-jumper-jackson-hoodie-dusky-rose S",
                  "breastfeeding-hoodie-everyday-hoodie-provence-blue S",
                  "breastfeeding-sweatshirt-jackson-mist-green S",
                  "breastfeeding-sweatshirt-jackson-black S",
                  "breastfeeding-t-shirt-charlotte-tee-tie-dye-ocean S",
                  "maternity-top-deluxe-long-sleeve-black S",
                  "breastfeeding-tops-casual-tank-black S",
                  "maternity-tops-bamboo-long-sleeve-tui-blue S"

              ],
              "96":[
                  "breastfeeding-jumper-jackson-hoodie-dusky-rose M",
                  "breastfeeding-hoodie-everyday-hoodie-provence-blue M",
                  "breastfeeding-sweatshirt-jackson-mist-green M",
                  "breastfeeding-sweatshirt-jackson-black M",
                  "breastfeeding-t-shirt-charlotte-tee-tie-dye-ocean M",
                  "maternity-top-deluxe-long-sleeve-black M",
                  "breastfeeding-tops-casual-tank-black M",
                  "maternity-tops-bamboo-long-sleeve-tui-blue M"

              ],
              "101":[
                  "breastfeeding-jumper-jackson-hoodie-dusky-rose L",
                  "breastfeeding-hoodie-everyday-hoodie-provence-blue L",
                  "breastfeeding-sweatshirt-jackson-mist-green L",
                  "breastfeeding-sweatshirt-jackson-black L",
                  "breastfeeding-t-shirt-charlotte-tee-tie-dye-ocean L",
                  "maternity-top-deluxe-long-sleeve-black L",
                  "breastfeeding-tops-casual-tank-black L",
                  "maternity-tops-bamboo-long-sleeve-tui-blue L"

              ],
              "106":[
                  "breastfeeding-jumper-jackson-hoodie-dusky-rose XL",
                  "breastfeeding-hoodie-everyday-hoodie-provence-blue XL",
                  "breastfeeding-sweatshirt-jackson-mist-green XL",
                  "breastfeeding-sweatshirt-jackson-black XL",
                  "breastfeeding-t-shirt-charlotte-tee-tie-dye-ocean XL",
                  "maternity-top-deluxe-long-sleeve-black XL",
                  "breastfeeding-tops-casual-tank-black XL",
                  "maternity-tops-bamboo-long-sleeve-tui-blue XL"

              ],
              "111":[
                    "breastfeeding-jumper-jackson-hoodie-dusky-rose 2XL",
                  "breastfeeding-hoodie-everyday-hoodie-provence-blue 2XL",
                  "breastfeeding-sweatshirt-jackson-mist-green 2XL",
                  "breastfeeding-sweatshirt-jackson-black 2XL",
                  "breastfeeding-t-shirt-charlotte-tee-tie-dye-ocean 2XL",
                  "maternity-top-deluxe-long-sleeve-black 2XL",
                  "breastfeeding-tops-casual-tank-black 2XL"

              ],
              "116":[
                    "breastfeeding-jumper-jackson-hoodie-dusky-rose 2XL",
                  "breastfeeding-hoodie-everyday-hoodie-provence-blue 2XL",
                  "breastfeeding-sweatshirt-jackson-mist-green 2XL",
                  "breastfeeding-sweatshirt-jackson-black 2XL",
                  "breastfeeding-t-shirt-charlotte-tee-tie-dye-ocean 2XL",
                  "maternity-top-deluxe-long-sleeve-black 2XL",
                  "breastfeeding-tops-casual-tank-black 2XL",
                  "maternity-tops-bamboo-long-sleeve-tui-blue 2XL"

              ],
              "121":[
                  "breastfeeding-jumper-jackson-hoodie-dusky-rose 3XL",
                  "breastfeeding-hoodie-everyday-hoodie-provence-blue 3XL",
                  "breastfeeding-sweatshirt-jackson-mist-green 3XL",
                  "breastfeeding-sweatshirt-jackson-black 3XL",
                  "breastfeeding-t-shirt-charlotte-tee-tie-dye-ocean 3XL",
                  "maternity-top-deluxe-long-sleeve-black 3XL",
                  "breastfeeding-tops-casual-tank-black 3XL",
                  "maternity-tops-bamboo-long-sleeve-tui-blue 3XL"

              ],
          },
          "D":{
              "80":[
                 "breastfeeding-jumper-jackson-hoodie-dusky-rose XS",
                  "breastfeeding-hoodie-everyday-hoodie-provence-blue XS",
                  "breastfeeding-sweatshirt-jackson-mist-green XS",
                  "breastfeeding-sweatshirt-jackson-black XS",
                  "breastfeeding-t-shirt-charlotte-tee-tie-dye-ocean XS",
                  "maternity-top-deluxe-long-sleeve-black XS",
                  "breastfeeding-tops-casual-tank-black XS",
                  "maternity-tops-bamboo-long-sleeve-tui-blue XS"

              ],
              "85":[
                   "breastfeeding-jumper-jackson-hoodie-dusky-rose S",
                  "breastfeeding-hoodie-everyday-hoodie-provence-blue S",
                  "breastfeeding-sweatshirt-jackson-mist-green S",
                  "breastfeeding-sweatshirt-jackson-black S",
                  "breastfeeding-t-shirt-charlotte-tee-tie-dye-ocean S",
                  "maternity-top-deluxe-long-sleeve-black S",
                  "breastfeeding-tops-casual-tank-black S",
                  "maternity-tops-bamboo-long-sleeve-tui-blue S"

              ],
              "91":[
                  "breastfeeding-jumper-jackson-hoodie-dusky-rose M",
                  "breastfeeding-hoodie-everyday-hoodie-provence-blue M",
                  "breastfeeding-sweatshirt-jackson-mist-green M",
                  "breastfeeding-sweatshirt-jackson-black M",
                  "breastfeeding-t-shirt-charlotte-tee-tie-dye-ocean M",
                  "maternity-top-deluxe-long-sleeve-black M",
                  "breastfeeding-tops-casual-tank-black M",
                  "maternity-tops-bamboo-long-sleeve-tui-blue M"

              ],
              "96":[
                 "breastfeeding-jumper-jackson-hoodie-dusky-rose L",
                  "breastfeeding-hoodie-everyday-hoodie-provence-blue L",
                  "breastfeeding-sweatshirt-jackson-mist-green L",
                  "breastfeeding-sweatshirt-jackson-black L",
                  "breastfeeding-t-shirt-charlotte-tee-tie-dye-ocean L",
                  "maternity-top-deluxe-long-sleeve-black L",
                  "breastfeeding-tops-casual-tank-black L",
                  "maternity-tops-bamboo-long-sleeve-tui-blue L"

              ],
              "101":[
                   "breastfeeding-jumper-jackson-hoodie-dusky-rose XL",
                  "breastfeeding-hoodie-everyday-hoodie-provence-blue XL",
                  "breastfeeding-sweatshirt-jackson-mist-green XL",
                  "breastfeeding-sweatshirt-jackson-black XL",
                  "breastfeeding-t-shirt-charlotte-tee-tie-dye-ocean XL",
                  "maternity-top-deluxe-long-sleeve-black XL",
                  "breastfeeding-tops-casual-tank-black XL",
                  "maternity-tops-bamboo-long-sleeve-tui-blue XL"

              ],
              "106":[
                      "breastfeeding-jumper-jackson-hoodie-dusky-rose 2XL",
                  "breastfeeding-hoodie-everyday-hoodie-provence-blue 2XL",
                  "breastfeeding-sweatshirt-jackson-mist-green 2XL",
                  "breastfeeding-sweatshirt-jackson-black 2XL",
                  "breastfeeding-t-shirt-charlotte-tee-tie-dye-ocean 2XL",
                  "maternity-top-deluxe-long-sleeve-black 2XL",
                  "breastfeeding-tops-casual-tank-black 2XL",
                  "maternity-tops-bamboo-long-sleeve-tui-blue 2XL"

              ],
              "111":[
                  "breastfeeding-jumper-jackson-hoodie-dusky-rose 2XL",
                  "breastfeeding-hoodie-everyday-hoodie-provence-blue 2XL",
                  "breastfeeding-sweatshirt-jackson-mist-green 2XL",
                  "breastfeeding-sweatshirt-jackson-black 2XL",
                  "breastfeeding-t-shirt-charlotte-tee-tie-dye-ocean 2XL",
                  "maternity-top-deluxe-long-sleeve-black 2XL",
                  "breastfeeding-tops-casual-tank-black 2XL",
                  "maternity-tops-bamboo-long-sleeve-tui-blue 2XL"

              ],

              "116":[
                  "breastfeeding-jumper-jackson-hoodie-dusky-rose 3XL",
                  "breastfeeding-hoodie-everyday-hoodie-provence-blue 3XL",
                  "breastfeeding-sweatshirt-jackson-mist-green 3XL",
                  "breastfeeding-sweatshirt-jackson-black 3XL",
                  "breastfeeding-t-shirt-charlotte-tee-tie-dye-ocean 3XL",
                  "maternity-top-deluxe-long-sleeve-black 3XL",
                  "breastfeeding-tops-casual-tank-black 3XL",
                  "maternity-tops-bamboo-long-sleeve-tui-blue 3XL"

              ],
              "121":[
             "breastfeeding-jumper-jackson-hoodie-dusky-rose 3XL",
                  "breastfeeding-hoodie-everyday-hoodie-provence-blue 3XL",
                  "breastfeeding-sweatshirt-jackson-mist-green 3XL",
                  "breastfeeding-sweatshirt-jackson-black 3XL",
                  "breastfeeding-t-shirt-charlotte-tee-tie-dye-ocean 3XL",
                  "maternity-top-deluxe-long-sleeve-black 3XL",
                  "breastfeeding-tops-casual-tank-black 3XL",
                  "maternity-tops-bamboo-long-sleeve-tui-blue 3XL"


              ],
          }
      };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-quiz"]) return;
  try {
    
      $('.start-btn').on('click', function () {
          setTimeout(function () {
              $('.mobile-scroll').scrollLeft(60);
          }, 10);
      });


      $('#slide3-btn-2').on('click', function () {
          if (!$('input[name=band_fit]:checked').val()) {
              $('input[name=band_fit]').eq(1).prop("checked", true);
          }
          if (!$('input[name=cup_fit]:checked').val()) {
              $('input[name=cup_fit]').eq(1).prop("checked", true);
          }
          if (!$('input[name=stage]:checked').val()) {
              $('input[name=stage]').eq(1).prop("checked", true);
          }
          if (!$('input[name=support_level]:checked').val()) {
              $('input[name=support_level]').eq(1).prop("checked", true);
          }
      });


      let fit_sizes = ['Too loose, rides up my back.', 'Too loose, rides up my back.', 'Too tight, dips in and feels uncomfortable.', 'Perfect! It’s comfortable and fits well.', 'Perfect! It’s comfortable and fits well.'];
      addMobileSlider("jssor_1", fit_sizes, '.band-fit', 750, 'band_fit');

      let cup_fit_sizes = ['Perfect!', 'Perfect!', 'My breasts are squashed and overflow.', 'My Cup isn’t full, and gaps alot.', 'My Cup isn’t full, and gaps alot.'];
      addMobileSlider("jssor_2", cup_fit_sizes, '.cup-fit', 750, 'cup_fit');

      let stages = ['1st Trimester', '1st Trimester', '2nd Trimester', '3rd Trimester', 'Breastfeeding', 'Neither, just love Cadenshae!', 'Neither, just love Cadenshae!'];
      addMobileSlider("jssor_3", stages, '.pregnancy-stage', 550, 'stage');

      let support_level = ['Low', 'Low', 'Moderate', 'High', 'High'];
      addMobileSlider("jssor_4", support_level, '.support-level', 750, 'support_level');


      function addMobileSlider(elementId, selectionTexts, parentSelector, slideWidth, radioName) {
          window.jssor_1_slider_init = function () {

              var slider_options = {
                  $AutoPlay: 0,
                  $SlideWidth: slideWidth,
                  $Loop: 0,
                  $StartIndex: 2
              };

              var slider = new $JssorSlider$(elementId, slider_options);

              slider.$On($JssorSlider$.$EVT_PARK, function (slideIndex, fromIndex) {
                  var slideIndex2 = Math.round(slider.$CurrentPosition());
                  $(parentSelector).find('.slider-text').text(selectionTexts[slideIndex2]);

                  if (slideIndex2 == 0) {
                      slider.$PlayTo(1);
                  }
                  if (slideIndex2 == slider.$SlidesCount() - 1) {
                      slider.$PlayTo(slider.$SlidesCount() - 2);
                  }

                  $('input[name=' + radioName + ']').each(function (index) {
                      if (index + 1 == slideIndex2) {
                          $(this).prop("checked", true);
                      } else {
                          $(this).prop("checked", false);
                      }
                  });

              });

              /*#region responsive code begin*/

              var MAX_WIDTH = 980;

              function ScaleSlider() {
                  var containerElement = slider.$Elmt.parentNode;
                  var containerWidth = containerElement.clientWidth;

                  if (containerWidth) {
                      var expectedWidth = Math.min(MAX_WIDTH || containerWidth, containerWidth);
                      slider.$ScaleWidth(expectedWidth);
                  } else {
                      window.setTimeout(ScaleSlider, 30);
                  }
              }

              ScaleSlider();

              $Jssor$.$AddEvent(window, "load", ScaleSlider);
              $Jssor$.$AddEvent(window, "resize", ScaleSlider);
              $Jssor$.$AddEvent(window, "orientationchange", ScaleSlider);
              /*#endregion responsive code end*/
          };
          jssor_1_slider_init();
      }

      $(window).resize(function () {
          displayRadioBar();
      });


      function displayRadioBar() {
          setTimeout(function () {
              radioBarPositioning(".band-fit");
              radioBarPositioning(".cup-fit");
              radioBarPositioning(".pregnancy-stage");
              radioBarPositioning(".support-level");
          }, 1000);
      }

      function radioBarPositioning(selector) {
          let firstRadioPos = $(selector).find(".fit-first-radio").offset();
          let newLeft = firstRadioPos.left + 7;
          let lastRadioPos = $(selector).find(".fit-last-radio").offset();
          let newWidth = (lastRadioPos.left - newLeft) + 3;
          let newTop = firstRadioPos.top + 7;
          $(selector).find(".fit-bar").css({top: newTop, left: newLeft, width: newWidth});
      }


      $('.carousel').carousel('pause');

      $('input').on('input', function () {
          if ($('input[name=band_size]:checked').val() && $('input[name=cup_size]:checked').val()) {
              $('#slide2-btn').prop('disabled', false);
          }
          if ($('input[name=band_fit]:checked').val()) {
              $('#slide3-btn').prop('disabled', false);
          }
          if ($('input[name=cup_fit]:checked').val()) {
              $('#slide4-btn').prop('disabled', false);
          }
          if ($('input[name=stage]:checked').val()) {
              $('#slide5-btn').prop('disabled', false);
          }
          if ($('input[name=support_level]:checked').val()) {
              $('#slide6-btn').prop('disabled', false);
          }
          if ($('#email').is(':valid')) {
              $('#slide8-btn').prop('disabled', false);
          }
      });

      $('.back-btn').on('click', function () {
          $('.carousel').carousel('prev');
          displayRadioBar();
      });

      $('.next-btn').on('click', function () {
          $('.carousel').carousel('next');
          displayRadioBar();
      });

      function getAnswers() {
          let stages = ['1st Trimester', '2nd Trimester', '3rd Trimester', 'Breastfeeding', 'Neither'];
          let supportLevels = ['Low', 'Moderate', 'High'];

          return {
              'bottom': $('input[name=bottom_size]:checked').val(),
              'band': getBandSize(),
              'cup': getCupSize(),
              'email': $('#email').val(),
              'stage': stages[$('input[name=stage]:checked').val()],
              'support': supportLevels[$('input[name=support_level]:checked').val() - 1]
          };
      }

      $('#slide8-btn').on('click', function () {
          let answers = getAnswers();
          updateUrl(answers);
  		fbq('track', 'Lead');

          _learnq.push(['identify', {
              '$email': answers.email,
              'Pregnancy Stage': answers.stage,
              'Support Level': answers.support,
              'Bottom Size': answers.bottom,
              'Band Size': answers.band,
              'Cup Size': answers.cup
          }]);

  	  	_learnq.push(['track', 'Bra Quiz', {
              'items': klavyoItems
          }]);
      });

      $('#not-now-btn').on('click', function () {
          updateUrl(getAnswers());
      });



      $('#restart-quiz').click(function(e) {
  		e.preventDefault();
  		localStorage.removeItem("quiz-results");
  		window.location = '/pages/size-quiz';
  	});

      function updateUrl(answers) {
          let queryString = $.param(answers);
          window.history.pushState(" ", "Quiz Results", "?" + queryString);
  		localStorage.setItem("quiz-results", queryString);
      }


      function getBandSize() {
          let band = parseInt($('input[name=band_size]:checked').val());
          let band_fit = $('input[name=band_fit]:checked').val();
          if (band_fit == 'loose' && band != 8) {
              band = band - 2;
          } else if (band_fit == 'tight' && band != 20) {
              band = band + 2;
          }
          return band;
      }

      function getCupSize() {
          let cup = $('input[name=cup_size]:checked').val();
          let cup_fit = $('input[name=cup_fit]:checked').val();
          let cupSizeNumber = cupSizes.indexOf(cup);
          if (cup_fit == 'tight' && cup != 'A') {
              cupSizeNumber = cupSizeNumber + 1;
          } else if (cup_fit == 'loose' && cup != 'J') {
              cupSizeNumber = cupSizeNumber - 1;
          }

          return cupSizes[cupSizeNumber];
      }

      $(document).ready(function() {
          let queryVars = getUrlVars();
          if (queryVars.bottom) {
              loadProducts(queryVars);
              $('.carousel').carousel(8);
          }
      });

      function getUrlVars() {
          var vars = [], hash;
          var hashes = [];
  		if (window.location.href.indexOf('?') > 0) {
  			hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  		} else if (localStorage.getItem("quiz-results")) {
  			hashes = localStorage.getItem("quiz-results").split('&');
  		}
  		for(var i = 0; i < hashes.length; i++)
          {
              hash = hashes[i].split('=');
              vars.push(hash[0]);
              vars[hash[0]] = hash[1];
          }

          return vars;
      }

      $('#slide6-btn').on('click', function () {
          loadProducts(getAnswers());
      });

      $('#slide6-btn-2').on('click', function () {
          loadProducts(getAnswers());
      });


      let klavyoItems = [];
      function loadProducts(answers) {
          //    addTips(answers.stage);

          let displayLevels = [];
          if (answers.support == 'Low') {
              displayLevels = ['Low', 'Moderate', 'High'];
          } else if (answers.support == 'Moderate') {
              displayLevels = ['Moderate', 'High', 'Low'];
          } else {
              displayLevels = ['High', 'Moderate', 'Low'];
          }
          addSupportLevels(displayLevels);
          for (let levelName in braMatrix[answers.band][answers.cup]) {
              if (!braMatrix[answers.band][answers.cup].hasOwnProperty(levelName)) continue;

              let level = braMatrix[answers.band][answers.cup][levelName];
              level.forEach(function (item, index) {
                  let parts = item.split(' ');
                  let productHandle = parts[0];
                  let size = parts[1];
                  allProductsLoader(function(allProducts) {
  		    		let product = allProducts[productHandle];
                      if (product) {
                        displayLoadedProduct(product, size, levelName, allProducts);
                      }
                  });
              });
          }
      }

      function addSupportLevels(levels) {
          levels.forEach(function (item, index) {
              let template = '<h3 class="my-4" style="display:none;" id="results-title-' + item + '">' + item + ' Support</h3>' +
                  '<div class="row row-cols-md-3 no-gutters product-row" id="product-results-' + item + '"></div>';
              $('.results').append(template);
          });
      }


      function displayLoadedProduct(item, size, level, allProducts) {
          $('#results-title-' + level).show();

          let product = item;
          let variantId = '';
          let available = false;
          product.variants.forEach(function (variant, key) {
              if (variant.title == 'XS / 8' && size == 'XS') {
                  variantId = variant.id;
                  available = variant.available;
              } else if (variant.title == 'S / 10' && size == 'S') {
                  variantId = variant.id;
                  available = variant.available;
              } else if (variant.title == 'M / 12' && size == 'M') {
                  variantId = variant.id;
                  available = variant.available;
              } else if (variant.title == 'L / 14' && size == 'L') {
                  variantId = variant.id;
                  available = variant.available;
              } else if (variant.title == 'XL+ / 16-20' && size == 'XL') {
                  variantId = variant.id;
                  available = variant.available;
              }
          });

          let klavyoProduct = product;
          klavyoProduct.selectedSize = size;
          klavyoProduct.selectedVariant = variantId;
          klavyoProduct.selectedVariantAvailable = available;
          klavyoProduct.description = '';
          klavyoItems.push(klavyoProduct);


              let sizeWidths = Object.keys(product.images[0].sizes).reverse();
              let sizes = Object.values(product.images[0].sizes).reverse();
              let imagesHtml = '';
              $.each(sizes,function(key,imgsize) {
                if (key >= sizes.length-2) {
                  return;
                }
                imagesHtml += '<source media="(min-width: '+sizeWidths[key+1]+'px)" srcset="'+imgsize+'">';
             });

          product.price = $('.size-quiz').attr('data-price-format').replace('0.00', (product.price/100).toFixed(2));
          colourHtml = '';
          $.each(product.colour_group,function(key,handle) {
            if (allProducts.hasOwnProperty(handle) && allProducts[handle].online) {
              colourHtml += '<a href="/products/'+handle+'" data-handle="'+handle+'" class="colour-picker rounded-circle mr-2 '+ (handle == product.handle ? 'border' : '')+'">'+
                  '<img class="rounded-circle alt-colour" src="'+allProducts[handle].swatch+'" alt="Alternate Colours">'+
                '</a>';
            }
          });


          let template = '<div class="col col-9 col-md-4 product-col">' +
              '<div class="container grid-item pb-0">' +
                '<div class="main-image-frame position-relative">' +
                  '<a href="/products/' + product.handle + '?variant=' + variantId + '">' +
  				  '<picture class="main-image">'+
                      imagesHtml+
                      '<img class="img-fluid" src="'+product.images[0].sizes[105]+'" alt="'+product.images[0].alt+'">'+
                    '</picture>'+
  '<span class="d-md-none plus-symbol" data-handle="'+product.handle+'" data-varaint-id="'+variantId+'" data-toggle="modal" data-target="#other-product-modal">+</span>'+
  '<div class="position-absolute quick-view-button-wrapper d-flex justify-content-center">'+
            '<button class="quick-view-button d-none d-md-block" type="button" data-varaint-id="'+variantId+'" data-handle="'+product.handle+'" data-toggle="modal" data-target="#other-product-modal">+ Quick View</button>'+
            '</div>'+
                  '</a>' +
                '</div>' +
                '<div class="row details">' +
                  '<div class="col py-2 text-center">' +
                    '<span class="no-wrap d-block"><a href="/products/' + product.handle + '?variant=' + variantId + '">' +
  					product.title.replace(product.colour,'') + '</a></span>' +
                    '<span class="price mb-2">' + product.price + '</span>' +

  				'<div class="colour-pickers" data-handle="'+product.handle+'">'+
                    colourHtml+
                  '</div>'+
  				(available ?
  				'<button class="btn add-to-cart" data-handle="'+product.handle+'" data-variant-title="'+size+'" data-variant-id="'+variantId+'" data-product-title="'+product.title+'" data-image-url="'+product.images[0].sizes['105']+'" data-price="'+product.price+'">'+
  					'Size ' + size + ' - Add to cart</button>'
  				: 'Size ' + size + ' - Out of stock')+
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>';

          $('#product-results-' + level).append(template);
  		addQuickViewEvent();
      }

    function addQuickViewEvent() {
      $('#quiz-slider').find('.quick-view-button').click(function(e) {
        e.preventDefault();
      });

      $('.main-image-frame').off('hover');
      $('.main-image-frame').hover(function(){
        $(this).find('.quick-view-button').addClass('hovered');
      },function(){
        $(this).find('.quick-view-button').removeClass('hovered');
      });

      $('#quiz-slider .plus-symbol').off('click');
      $('#quiz-slider .plus-symbol').click(function(e){e.preventDefault();});

      $('#quiz-slider .add-to-cart').off('click');
      $('#quiz-slider .add-to-cart').click(function(){
        addToSideCart($(this).attr('data-variant-id'),$(this).attr('data-price'),$(this).attr('data-image-url'),$(this).attr('data-product-title'),$(this).attr('data-variant-title'),$(this).attr('data-handle'));
        showSideCart();
      });
    }

      let cupSizes = ['A', 'B', 'C', 'D', 'DD', 'E', 'F', 'FF', 'G', 'GG', 'H', 'HH', 'I', 'J'];



  let braMatrix = {"8":{"A":{"High":["breastfeeding-bra-maya-bra-sakura XS","racerback-nursing-bra-everyday-black XS","crossover-nursing-sports-bra-evolve-bra-sugar-plum XS","nursing-sports-bra-embrace-stellar XS","breastfeeding-bra-bloom-thrive-bra-blossom XS"],"Moderate":["breastfeeding-bra-freedom-bra-forest XS"],"Low":["maternity-sleep-bra-hush-seamless-bamboo-bra S"]},"B":{"High":["breastfeeding-bra-freedom-bra-black XS","maternity-activewear-bra-fit2feed-black XS","breastfeeding-bra-maya-bra-sakura XS","racerback-nursing-bra-everyday-black XS","maternity-bra-swift-bra-whisper XS","crossover-nursing-sports-bra-evolve-bra-sugar-plum XS","nursing-sports-bra-embrace-stellar XS","breastfeeding-bra-bloom-thrive-bra-blossom XS"],"Moderate":["breastfeeding-bra-freedom-bra-forest XS"],"Low":["maternity-sleep-bra-hush-seamless-bamboo-bra S"]},"C":{"High":["breastfeeding-bra-freedom-bra-black XS","maternity-activewear-bra-fit2feed-black XS","breastfeeding-bra-maya-bra-sakura XS","maternity-bra-swift-bra-whisper XS","crossover-nursing-sports-bra-evolve-bra-sugar-plum XS","nursing-sports-bra-embrace-stellar XS","breastfeeding-bra-bloom-thrive-bra-blossom XS"],"Moderate":["racerback-nursing-bra-everyday-black XS"],"Low":["breastfeeding-bra-freedom-bra-forest XS","maternity-sleep-bra-hush-seamless-bamboo-bra S"]},"D":{"Moderate":["breastfeeding-bra-freedom-bra-black XS","breastfeeding-bra-maya-bra-sakura XS","racerback-nursing-bra-everyday-black XS"],"High":["maternity-activewear-bra-fit2feed-black XS","maternity-bra-swift-bra-whisper XS","crossover-nursing-sports-bra-evolve-bra-sugar-plum XS","nursing-sports-bra-embrace-stellar XS","breastfeeding-bra-bloom-thrive-bra-blossom XS"],"Low":["breastfeeding-bra-freedom-bra-forest XS","maternity-sleep-bra-hush-seamless-bamboo-bra S"]},"DD":{"Moderate":["breastfeeding-bra-freedom-bra-black XS","breastfeeding-bra-maya-bra-sakura XS","crossover-nursing-sports-bra-evolve-bra-sugar-plum XS","breastfeeding-bra-bloom-thrive-bra-blossom XS"],"High":["maternity-activewear-bra-fit2feed-black XS","maternity-bra-swift-bra-whisper XS","nursing-sports-bra-embrace-stellar S"],"Low":["racerback-nursing-bra-everyday-black XS","maternity-sleep-bra-hush-seamless-bamboo-bra S"]},"E":{"High":["nursing-sports-bra-ultimate-bra-black XS","maternity-activewear-bra-fit2feed-black XS","nursing-sports-bra-ultimate-high-impact-bra-white XS"],"Low":["breastfeeding-bra-freedom-bra-black XS","breastfeeding-bra-maya-bra-sakura XS","racerback-nursing-bra-everyday-black XS","maternity-sleep-bra-hush-seamless-bamboo-bra S"],"Moderate":["crossover-nursing-sports-bra-evolve-bra-sugar-plum XS","breastfeeding-bra-bloom-thrive-bra-blossom XS"]},"F":{"High":["nursing-sports-bra-ultimate-bra-black XS","nursing-sports-bra-ultimate-high-impact-bra-white XS"],"Low":["crossover-nursing-sports-bra-evolve-bra-sugar-plum S","breastfeeding-bra-bloom-thrive-bra-blossom S"]},"FF":{"High":["nursing-sports-bra-ultimate-bra-black XS","nursing-sports-bra-ultimate-high-impact-bra-white XS"]},"G":{"High":["nursing-sports-bra-ultimate-bra-black XS","nursing-sports-bra-ultimate-high-impact-bra-white XS"]},"GG":{"High":["nursing-sports-bra-ultimate-bra-black S","nursing-sports-bra-ultimate-high-impact-bra-white S"]},"H":{"High":["plus-size-nursing-bra-luxe-bra-charm XS"]},"HH":{"High":["plus-size-nursing-bra-luxe-bra-charm XS"]},"I":{"High":["plus-size-nursing-bra-luxe-bra-charm XS"]},"J":{"High":["plus-size-nursing-bra-luxe-bra-charm XS"]}},"10":{"A":{"High":["breastfeeding-bra-maya-bra-sakura S","racerback-nursing-bra-everyday-black S","crossover-nursing-sports-bra-evolve-bra-sugar-plum S","nursing-sports-bra-embrace-stellar XS","breastfeeding-bra-bloom-thrive-bra-blossom S"],"Moderate":["breastfeeding-bra-freedom-bra-forest S"],"Low":["maternity-sleep-bra-hush-seamless-bamboo-bra S"]},"B":{"High":["breastfeeding-bra-freedom-bra-black S","maternity-activewear-bra-fit2feed-black S","breastfeeding-bra-maya-bra-sakura S","racerback-nursing-bra-everyday-black S","maternity-bra-swift-bra-whisper XS","crossover-nursing-sports-bra-evolve-bra-sugar-plum S","nursing-sports-bra-embrace-stellar S","breastfeeding-bra-bloom-thrive-bra-blossom S"],"Moderate":["breastfeeding-bra-freedom-bra-forest S"],"Low":["maternity-sleep-bra-hush-seamless-bamboo-bra S"]},"C":{"High":["breastfeeding-bra-freedom-bra-black S","maternity-activewear-bra-fit2feed-black S","breastfeeding-bra-maya-bra-sakura S","maternity-bra-swift-bra-whisper S","crossover-nursing-sports-bra-evolve-bra-sugar-plum S","nursing-sports-bra-embrace-stellar S","breastfeeding-bra-bloom-thrive-bra-blossom S"],"Moderate":["racerback-nursing-bra-everyday-black S"],"Low":["breastfeeding-bra-freedom-bra-forest S","maternity-sleep-bra-hush-seamless-bamboo-bra S"]},"D":{"High":["nursing-sports-bra-ultimate-bra-black XS","breastfeeding-bra-freedom-bra-black S","maternity-activewear-bra-fit2feed-black S","maternity-bra-swift-bra-whisper S","crossover-nursing-sports-bra-evolve-bra-sugar-plum S","nursing-sports-bra-embrace-stellar S","breastfeeding-bra-bloom-thrive-bra-blossom S"],"Moderate":["breastfeeding-bra-maya-bra-sakura S","racerback-nursing-bra-everyday-black S"],"Low":["breastfeeding-bra-freedom-bra-forest S","maternity-sleep-bra-hush-seamless-bamboo-bra S"]},"DD":{"High":["nursing-sports-bra-ultimate-bra-black XS","maternity-activewear-bra-fit2feed-black S","crossover-nursing-sports-bra-evolve-bra-sugar-plum S","nursing-sports-bra-ultimate-high-impact-bra-white XS","breastfeeding-bra-bloom-thrive-bra-blossom S"],"Moderate":["breastfeeding-bra-freedom-bra-black S","breastfeeding-bra-maya-bra-sakura S","maternity-bra-swift-bra-whisper S"],"Low":["racerback-nursing-bra-everyday-black S","maternity-sleep-bra-hush-seamless-bamboo-bra S"]},"E":{"High":["nursing-sports-bra-ultimate-bra-black S","maternity-activewear-bra-fit2feed-black S","nursing-sports-bra-ultimate-high-impact-bra-white S"],"Low":["breastfeeding-bra-freedom-bra-black S","breastfeeding-bra-maya-bra-sakura S","racerback-nursing-bra-everyday-black S","maternity-sleep-bra-hush-seamless-bamboo-bra S"],"Moderate":["maternity-bra-swift-bra-whisper S","crossover-nursing-sports-bra-evolve-bra-sugar-plum S","breastfeeding-bra-bloom-thrive-bra-blossom S"]},"F":{"High":["nursing-sports-bra-ultimate-bra-black S","nursing-sports-bra-ultimate-high-impact-bra-white S"],"Low":["crossover-nursing-sports-bra-evolve-bra-sugar-plum M","breastfeeding-bra-bloom-thrive-bra-blossom M"]},"FF":{"High":["nursing-sports-bra-ultimate-bra-black M","nursing-sports-bra-ultimate-high-impact-bra-white S"]},"G":{"High":["nursing-sports-bra-ultimate-bra-black M","plus-size-nursing-bra-luxe-bra-charm XS","nursing-sports-bra-ultimate-high-impact-bra-white S"]},"GG":{"High":["plus-size-nursing-bra-luxe-bra-charm XS"]},"H":{"High":["plus-size-nursing-bra-luxe-bra-charm S"]},"HH":{"High":["plus-size-nursing-bra-luxe-bra-charm S"]},"I":{"High":["plus-size-nursing-bra-luxe-bra-charm S"]},"J":{"High":["plus-size-nursing-bra-luxe-bra-charm S"]}},"12":{"A":{"High":["breastfeeding-bra-maya-bra-sakura M","racerback-nursing-bra-everyday-black S","crossover-nursing-sports-bra-evolve-bra-sugar-plum S","nursing-sports-bra-embrace-stellar S","breastfeeding-bra-bloom-thrive-bra-blossom S"],"Moderate":["breastfeeding-bra-freedom-bra-forest S"],"Low":["maternity-sleep-bra-hush-seamless-bamboo-bra M"]},"B":{"High":["breastfeeding-bra-freedom-bra-black M","maternity-activewear-bra-fit2feed-black M","breastfeeding-bra-maya-bra-sakura M","racerback-nursing-bra-everyday-black M","maternity-bra-swift-bra-whisper S","crossover-nursing-sports-bra-evolve-bra-sugar-plum S","nursing-sports-bra-embrace-stellar M","breastfeeding-bra-bloom-thrive-bra-blossom S"],"Moderate":["breastfeeding-bra-freedom-bra-forest S"],"Low":["maternity-sleep-bra-hush-seamless-bamboo-bra M"]},"C":{"High":["breastfeeding-bra-freedom-bra-black M","maternity-activewear-bra-fit2feed-black M","maternity-bra-swift-bra-whisper M","nursing-sports-bra-embrace-stellar M"],"Moderate":["breastfeeding-bra-maya-bra-sakura M","racerback-nursing-bra-everyday-black M","crossover-nursing-sports-bra-evolve-bra-sugar-plum M","breastfeeding-bra-bloom-thrive-bra-blossom M"],"Low":["breastfeeding-bra-freedom-bra-forest M","maternity-sleep-bra-hush-seamless-bamboo-bra M"]},"D":{"High":["nursing-sports-bra-ultimate-bra-black S","maternity-activewear-bra-fit2feed-black M","maternity-bra-swift-bra-whisper M","nursing-sports-bra-embrace-stellar M"],"Moderate":["breastfeeding-bra-freedom-bra-black M","breastfeeding-bra-maya-bra-sakura M","racerback-nursing-bra-everyday-black M","crossover-nursing-sports-bra-evolve-bra-sugar-plum M","breastfeeding-bra-bloom-thrive-bra-blossom M"],"Low":["breastfeeding-bra-freedom-bra-forest M","maternity-sleep-bra-hush-seamless-bamboo-bra M"]},"DD":{"High":["nursing-sports-bra-ultimate-bra-black S","maternity-activewear-bra-fit2feed-black M","nursing-sports-bra-ultimate-high-impact-bra-white S"],"Moderate":["breastfeeding-bra-freedom-bra-black M","maternity-bra-swift-bra-whisper M","crossover-nursing-sports-bra-evolve-bra-sugar-plum M","breastfeeding-bra-bloom-thrive-bra-blossom M"],"Low":["breastfeeding-bra-maya-bra-sakura M","racerback-nursing-bra-everyday-black M","maternity-sleep-bra-hush-seamless-bamboo-bra M"]},"E":{"High":["nursing-sports-bra-ultimate-bra-black M","maternity-activewear-bra-fit2feed-black M","nursing-sports-bra-ultimate-high-impact-bra-white M"],"Low":["breastfeeding-bra-freedom-bra-black M","breastfeeding-bra-maya-bra-sakura M","racerback-nursing-bra-everyday-black M","maternity-sleep-bra-hush-seamless-bamboo-bra M"],"Moderate":["crossover-nursing-sports-bra-evolve-bra-sugar-plum M","breastfeeding-bra-bloom-thrive-bra-blossom M"]},"F":{"High":["nursing-sports-bra-ultimate-bra-black M","nursing-sports-bra-ultimate-high-impact-bra-white M"],"Low":["crossover-nursing-sports-bra-evolve-bra-sugar-plum L","breastfeeding-bra-bloom-thrive-bra-blossom L"]},"FF":{"High":["nursing-sports-bra-ultimate-bra-black L","nursing-sports-bra-ultimate-high-impact-bra-white M"]},"G":{"High":["nursing-sports-bra-ultimate-bra-black L","plus-size-nursing-bra-luxe-bra-charm S","nursing-sports-bra-ultimate-high-impact-bra-white M"]},"GG":{"High":["nursing-sports-bra-ultimate-bra-black L","plus-size-nursing-bra-luxe-bra-charm S"]},"H":{"High":["plus-size-nursing-bra-luxe-bra-charm M"]},"HH":{"High":["plus-size-nursing-bra-luxe-bra-charm M"]},"I":{"High":["plus-size-nursing-bra-luxe-bra-charm M"]},"J":{"High":["plus-size-nursing-bra-luxe-bra-charm M"]}},"14":{"A":{"High":["breastfeeding-bra-maya-bra-sakura L","racerback-nursing-bra-everyday-black M","crossover-nursing-sports-bra-evolve-bra-sugar-plum M","nursing-sports-bra-embrace-stellar M","breastfeeding-bra-bloom-thrive-bra-blossom M"],"Moderate":["breastfeeding-bra-freedom-bra-forest M"],"Low":["maternity-sleep-bra-hush-seamless-bamboo-bra L"]},"B":{"High":["breastfeeding-bra-freedom-bra-black L","maternity-activewear-bra-fit2feed-black L","breastfeeding-bra-maya-bra-sakura L","racerback-nursing-bra-everyday-black L","maternity-bra-swift-bra-whisper M","nursing-sports-bra-embrace-stellar L"],"Low":["breastfeeding-bra-freedom-bra-forest L","maternity-sleep-bra-hush-seamless-bamboo-bra L"],"Moderate":["crossover-nursing-sports-bra-evolve-bra-sugar-plum L","breastfeeding-bra-bloom-thrive-bra-blossom L"]},"C":{"High":["breastfeeding-bra-freedom-bra-black L","maternity-activewear-bra-fit2feed-black L","maternity-bra-swift-bra-whisper L","nursing-sports-bra-embrace-stellar L"],"Moderate":["breastfeeding-bra-maya-bra-sakura L","racerback-nursing-bra-everyday-black L","crossover-nursing-sports-bra-evolve-bra-sugar-plum L","breastfeeding-bra-bloom-thrive-bra-blossom L"],"Low":["breastfeeding-bra-freedom-bra-forest L","maternity-sleep-bra-hush-seamless-bamboo-bra L"]},"D":{"High":["nursing-sports-bra-ultimate-bra-black M","maternity-activewear-bra-fit2feed-black L","maternity-bra-swift-bra-whisper L","nursing-sports-bra-embrace-stellar L"],"Moderate":["breastfeeding-bra-freedom-bra-black L","breastfeeding-bra-maya-bra-sakura L","racerback-nursing-bra-everyday-black L","crossover-nursing-sports-bra-evolve-bra-sugar-plum L","breastfeeding-bra-bloom-thrive-bra-blossom L"],"Low":["breastfeeding-bra-freedom-bra-forest L","maternity-sleep-bra-hush-seamless-bamboo-bra L"]},"DD":{"High":["nursing-sports-bra-ultimate-bra-black M","maternity-activewear-bra-fit2feed-black L","nursing-sports-bra-ultimate-high-impact-bra-white M"],"Moderate":["breastfeeding-bra-freedom-bra-black L","maternity-bra-swift-bra-whisper L","crossover-nursing-sports-bra-evolve-bra-sugar-plum L","breastfeeding-bra-bloom-thrive-bra-blossom L"],"Low":["breastfeeding-bra-maya-bra-sakura L","racerback-nursing-bra-everyday-black L","maternity-sleep-bra-hush-seamless-bamboo-bra L"]},"E":{"High":["nursing-sports-bra-ultimate-bra-black L","maternity-activewear-bra-fit2feed-black L","nursing-sports-bra-ultimate-high-impact-bra-white L"],"Low":["breastfeeding-bra-freedom-bra-black L","breastfeeding-bra-maya-bra-sakura L","racerback-nursing-bra-everyday-black L","maternity-bra-swift-bra-whisper L","maternity-sleep-bra-hush-seamless-bamboo-bra L"],"Moderate":["crossover-nursing-sports-bra-evolve-bra-sugar-plum L","breastfeeding-bra-bloom-thrive-bra-blossom L"]},"F":{"High":["nursing-sports-bra-ultimate-bra-black L","nursing-sports-bra-ultimate-high-impact-bra-white L"],"Low":["crossover-nursing-sports-bra-evolve-bra-sugar-plum XL","breastfeeding-bra-bloom-thrive-bra-blossom XL"]},"FF":{"High":["nursing-sports-bra-ultimate-bra-black L","nursing-sports-bra-ultimate-high-impact-bra-white L"]},"G":{"High":["nursing-sports-bra-ultimate-bra-black XL","plus-size-nursing-bra-luxe-bra-charm M","nursing-sports-bra-ultimate-high-impact-bra-white L"]},"GG":{"High":["plus-size-nursing-bra-luxe-bra-charm M"]},"H":{"High":["plus-size-nursing-bra-luxe-bra-charm L"]},"HH":{"High":["plus-size-nursing-bra-luxe-bra-charm L"]},"I":{"High":["plus-size-nursing-bra-luxe-bra-charm L"]},"J":{"High":["plus-size-nursing-bra-luxe-bra-charm L"]}},"16":{"A":{"High":["breastfeeding-bra-maya-bra-sakura XL","racerback-nursing-bra-everyday-black L","crossover-nursing-sports-bra-evolve-bra-sugar-plum L","nursing-sports-bra-embrace-stellar L","breastfeeding-bra-bloom-thrive-bra-blossom L"],"Moderate":["breastfeeding-bra-freedom-bra-forest L"],"Low":["maternity-sleep-bra-hush-seamless-bamboo-bra XL"]},"B":{"High":["breastfeeding-bra-freedom-bra-black XL","maternity-activewear-bra-fit2feed-black XL","breastfeeding-bra-maya-bra-sakura XL","maternity-bra-swift-bra-whisper L","crossover-nursing-sports-bra-evolve-bra-sugar-plum XL","nursing-sports-bra-embrace-stellar XL","breastfeeding-bra-bloom-thrive-bra-blossom XL"],"Moderate":["racerback-nursing-bra-everyday-black XL"],"Low":["breastfeeding-bra-freedom-bra-forest XL","maternity-sleep-bra-hush-seamless-bamboo-bra XL"]},"C":{"High":["breastfeeding-bra-freedom-bra-black XL","maternity-activewear-bra-fit2feed-black XL","maternity-bra-swift-bra-whisper XL","nursing-sports-bra-embrace-stellar XL"],"Moderate":["breastfeeding-bra-maya-bra-sakura XL","racerback-nursing-bra-everyday-black XL","crossover-nursing-sports-bra-evolve-bra-sugar-plum XL","breastfeeding-bra-bloom-thrive-bra-blossom XL"],"Low":["breastfeeding-bra-freedom-bra-forest XL","maternity-sleep-bra-hush-seamless-bamboo-bra XL"]},"D":{"High":["nursing-sports-bra-ultimate-bra-black L","maternity-activewear-bra-fit2feed-black XL","maternity-bra-swift-bra-whisper XL","nursing-sports-bra-embrace-stellar XL"],"Moderate":["breastfeeding-bra-freedom-bra-black XL","breastfeeding-bra-maya-bra-sakura XL","crossover-nursing-sports-bra-evolve-bra-sugar-plum XL","breastfeeding-bra-bloom-thrive-bra-blossom XL"],"Low":["racerback-nursing-bra-everyday-black XL","breastfeeding-bra-freedom-bra-forest XL","maternity-sleep-bra-hush-seamless-bamboo-bra XL"]},"DD":{"High":["nursing-sports-bra-ultimate-bra-black L","maternity-activewear-bra-fit2feed-black XL","nursing-sports-bra-ultimate-high-impact-bra-white L"],"Low":["breastfeeding-bra-freedom-bra-black XL","breastfeeding-bra-maya-bra-sakura XL","racerback-nursing-bra-everyday-black XL","maternity-sleep-bra-hush-seamless-bamboo-bra XL"],"Moderate":["maternity-bra-swift-bra-whisper XL","crossover-nursing-sports-bra-evolve-bra-sugar-plum XL","breastfeeding-bra-bloom-thrive-bra-blossom XL"]},"E":{"High":["nursing-sports-bra-ultimate-bra-black XL","nursing-sports-bra-ultimate-high-impact-bra-white XL"],"Low":["breastfeeding-bra-freedom-bra-black XL","breastfeeding-bra-maya-bra-sakura XL","racerback-nursing-bra-everyday-black XL","crossover-nursing-sports-bra-evolve-bra-sugar-plum XL","breastfeeding-bra-bloom-thrive-bra-blossom XL","maternity-sleep-bra-hush-seamless-bamboo-bra XL"],"Moderate":["maternity-activewear-bra-fit2feed-black XL"]},"F":{"High":["nursing-sports-bra-ultimate-bra-black XL","nursing-sports-bra-ultimate-high-impact-bra-white XL"]},"FF":{"High":["nursing-sports-bra-ultimate-bra-black XL","nursing-sports-bra-ultimate-high-impact-bra-white XL"]},"G":{"High":["nursing-sports-bra-ultimate-bra-black XL","plus-size-nursing-bra-luxe-bra-charm L","nursing-sports-bra-ultimate-high-impact-bra-white XL"]},"GG":{"High":["nursing-sports-bra-ultimate-bra-black XL","plus-size-nursing-bra-luxe-bra-charm L"]},"H":{"High":["plus-size-nursing-bra-luxe-bra-charm XL"]},"HH":{"High":["plus-size-nursing-bra-luxe-bra-charm XL"]},"I":{"High":["plus-size-nursing-bra-luxe-bra-charm XL"]},"J":{"High":["plus-size-nursing-bra-luxe-bra-charm XL"]}},"18":{"A":{"High":["breastfeeding-bra-maya-bra-sakura XL","racerback-nursing-bra-everyday-black XL"],"Low":["breastfeeding-bra-freedom-bra-forest XL","maternity-sleep-bra-hush-seamless-bamboo-bra XL"],"Moderate":["crossover-nursing-sports-bra-evolve-bra-sugar-plum XL","breastfeeding-bra-bloom-thrive-bra-blossom XL"]},"B":{"Moderate":["breastfeeding-bra-freedom-bra-black XL","racerback-nursing-bra-everyday-black XXL","crossover-nursing-sports-bra-evolve-bra-sugar-plum XL","breastfeeding-bra-bloom-thrive-bra-blossom XL"],"High":["maternity-activewear-bra-fit2feed-black XL","breastfeeding-bra-maya-bra-sakura XL","maternity-bra-swift-bra-whisper XL"],"Low":["breastfeeding-bra-freedom-bra-forest XL","maternity-sleep-bra-hush-seamless-bamboo-bra XL"]},"C":{"Moderate":["breastfeeding-bra-freedom-bra-black XL","breastfeeding-bra-maya-bra-sakura XL","racerback-nursing-bra-everyday-black XXL","crossover-nursing-sports-bra-evolve-bra-sugar-plum XL","breastfeeding-bra-bloom-thrive-bra-blossom XL"],"High":["maternity-activewear-bra-fit2feed-black XL","maternity-bra-swift-bra-whisper XL"],"Low":["breastfeeding-bra-freedom-bra-forest XL","maternity-sleep-bra-hush-seamless-bamboo-bra XL"]},"D":{"High":["nursing-sports-bra-ultimate-bra-black XL","maternity-activewear-bra-fit2feed-black XL","nursing-sports-bra-ultimate-high-impact-bra-white XL"],"Moderate":["breastfeeding-bra-freedom-bra-black XL","breastfeeding-bra-maya-bra-sakura XL","maternity-bra-swift-bra-whisper XXL","crossover-nursing-sports-bra-evolve-bra-sugar-plum XL","breastfeeding-bra-bloom-thrive-bra-blossom XL"],"Low":["racerback-nursing-bra-everyday-black XXL","maternity-sleep-bra-hush-seamless-bamboo-bra XL"]},"DD":{"High":["nursing-sports-bra-ultimate-bra-black XL","nursing-sports-bra-ultimate-high-impact-bra-white XL"],"Low":["breastfeeding-bra-freedom-bra-black XL","breastfeeding-bra-maya-bra-sakura XL","racerback-nursing-bra-everyday-black XXL","crossover-nursing-sports-bra-evolve-bra-sugar-plum XL","breastfeeding-bra-bloom-thrive-bra-blossom XL","maternity-sleep-bra-hush-seamless-bamboo-bra XL"],"Moderate":["maternity-activewear-bra-fit2feed-black XL","maternity-bra-swift-bra-whisper XXL"]},"E":{"High":["nursing-sports-bra-ultimate-bra-black 18","nursing-sports-bra-ultimate-high-impact-bra-white XL"],"Low":["breastfeeding-bra-freedom-bra-black XXL","breastfeeding-bra-maya-bra-sakura XXL","racerback-nursing-bra-everyday-black XXL","crossover-nursing-sports-bra-evolve-bra-sugar-plum XXL","breastfeeding-bra-bloom-thrive-bra-blossom XXL","maternity-sleep-bra-hush-seamless-bamboo-bra XL"],"Moderate":["maternity-activewear-bra-fit2feed-black XL","maternity-bra-swift-bra-whisper XXL"]},"F":{"High":["nursing-sports-bra-ultimate-bra-black 18","nursing-sports-bra-ultimate-high-impact-bra-white XL"]},"FF":{"High":["nursing-sports-bra-ultimate-bra-black 18","plus-size-nursing-bra-luxe-bra-charm XL"]},"G":{"High":["plus-size-nursing-bra-luxe-bra-charm XL"]},"GG":{"High":["plus-size-nursing-bra-luxe-bra-charm XL"]},"H":{"High":["plus-size-nursing-bra-luxe-bra-charm XL"]},"HH":{"High":["plus-size-nursing-bra-luxe-bra-charm XL"]},"I":{"High":["plus-size-nursing-bra-luxe-bra-charm XL"]}},"20":{"B":{"Low":["breastfeeding-bra-freedom-bra-black XXL","breastfeeding-bra-maya-bra-sakura Size XXL","crossover-nursing-sports-bra-evolve-bra-sugar-plum XXL","breastfeeding-bra-bloom-thrive-bra-blossom XXL"],"Moderate":["racerback-nursing-bra-everyday-black XXL"],"High":["maternity-bra-swift-bra-whisper XXL"]},"C":{"Low":["breastfeeding-bra-freedom-bra-black XXL","breastfeeding-bra-maya-bra-sakura Size XXL","racerback-nursing-bra-everyday-black XXL","crossover-nursing-sports-bra-evolve-bra-sugar-plum XXL","breastfeeding-bra-bloom-thrive-bra-blossom XXL"],"Moderate":["maternity-bra-swift-bra-whisper XXL"]},"D":{"Low":["breastfeeding-bra-freedom-bra-black XXL","Smoothie Crop- Size XXL","racerback-nursing-bra-everyday-black XXL","maternity-bra-swift-bra-whisper XXL","crossover-nursing-sports-bra-evolve-bra-sugar-plum XXL","breastfeeding-bra-bloom-thrive-bra-blossom XXL"]},"DD":{"High":["nursing-sports-bra-ultimate-bra-black 18"],"Low":["breastfeeding-bra-freedom-bra-black XXL","breastfeeding-bra-maya-bra-sakura Size XXL","racerback-nursing-bra-everyday-black XXL","maternity-bra-swift-bra-whisper XXL","crossover-nursing-sports-bra-evolve-bra-sugar-plum XXL","breastfeeding-bra-bloom-thrive-bra-blossom XXL"]},"E":{"High":["nursing-sports-bra-ultimate-bra-black 18"]},"F":{"High":["plus-size-nursing-bra-luxe-bra-charm XL"]},"FF":{"High":["plus-size-nursing-bra-luxe-bra-charm XL"]},"G":{"High":["plus-size-nursing-bra-luxe-bra-charm XL"]},"GG":{"High":["plus-size-nursing-bra-luxe-bra-charm XL"]}}};

  } catch(e) { console.error(e); }
})();
      })();
